import { FormattedMessage } from "react-intl";
import style from "react-syntax-highlighter/dist/esm/styles/hljs/a11y-dark";
export * from "./permissions";
export const GoogleMapsAPI = "AIzaSyBffHzTRoRv4_ULJFdyENWA50isLr-5Xx0"; // TODO: Move the API key in backend settings
export const ZIP_CODE_LENGTH = 10;
export const NON_WHITESPACES = "/^S+$";
export const PRESEVE_PREVIOUS_PRICE = "preserve_price";
export const PRESEVE_PREVIOUS_PRICE_ECOM = "preserve_price_ecom";
export const SUGGESTED_PRESERVE_PRICE_PORTAL = "suggested_preserve_price_portal";
export const SUGGESTED_PRESERVE_PRICE_ECOM = "suggested_preserve_price_ecom";
export const SHOW_PAY_NOW_AMOUNT_WARNING = "show_pay_now_amount_warning";
export const RESTRICT_GUEST_CUSTOMER_CHECKOUT = "restrict_guest_customer_checkout";

export const PRODUCT_DESCRIPTION = 2000
export const APPLY_ADDITIONAL_DISCOUNT = {
  BEFORE_TAX: { name: "Before Tax", value: true },
  AFTER_TAX: { name: "After Tax", value: false },
};
export const EDI_OPTIONS = {
  EDI_CUSTOM: { name: "EDI Custom", value: 1 },
  ECOM_ALLOW_TYPE: { name: "EDI Modisoft", value: 2 },
};

export const FOR_ADJUSTMENT = "For Adjustment";

export const NotAssigned = "Not assigned";
export const BarcodeOnUOM= {
    BASE_UOM : "base_uom",
    SOLD_BY_UOM : "sold_by_uom"
  }
// NOT unused — imported by Common/partials/invoice/Invoice.js,
// saleQOrder/add-form-page/complete-card, and SaleInvoiceSetting.js.
// Commenting these out (0aed2f6bf8) broke the tenant client build
// (esbuild: "No matching export").
export const DEFAULT_INVOICE_HEADER_TEMPLATE_ID = 1;
export const normalizeInvoiceHeaderTemplateId = (id) => {
  if (id === "default" || id === undefined || id === null || id === "") return DEFAULT_INVOICE_HEADER_TEMPLATE_ID;
  return Number(id);
};
export const CATEGORY_COMMA_SEPARATED_STRING_LIMIT = 35;
export const WEIGHT_TYPE = [
  {
    value: 1,
    type: "lb",
  },
  {
    value: 2,
    type: "oz",
  },
];

export const ExportListPickupDownloadedOptions = [
  { label: "Downloaded (Green Dot)", value: true },
  { label: "Not Downloaded(Empty Dot)", value: false },
];
export const ProductDisplayType = {
  LIST: { value: 5, label: "List" },
  IMAGE: { value: 1, label: "Image" },
  RECTANGLE_LIST: { value: 2, label: "Rectangular list" },
  RADIO_BUTTON: { value: 3, label: "Radio Buttons" },
  DROP_DOWN: { value: 4, label: "Dropdown" },
  GRID: { value: 6, label: "Grid View" },
};

export const ACCOUNT_TYPES = {
  CASH: 8,
  BANK: 9,
  CREDIT_CARD: 14,
};

export const ACCOUNT_TYPE_GROUPS = {
  ALL_ACCOUNTS: [ACCOUNT_TYPES.CASH, ACCOUNT_TYPES.BANK, ACCOUNT_TYPES.CREDIT_CARD],
};

export const AGE_THRESHOLD_OPTIONS = [
  { value: 18, label: "18 Plus" },
  { value: 21, label: "21 Plus" },
];

export const awsFileUploadUrl = "https://khub-app.s3-accelerate.amazonaws.com/";
export const PAYMENT_RETURN_TYPES = [
  {
    value: 1,
    type: "Cash",
    id: "control_01",
    name: "CASH",
    active: true,
  },
  {
    value: 2,
    type: "Cheque",
    id: "control_02",
    name: "CHEQUE",
    active: true,
  },
  {
    value: 6,
    type2: "Customer Credit Added",
    type: <FormattedMessage id="Customer Credit Added" defaultMessage="Customer Credit Added" />,
    id: "control_06",
    name: "CUSTOMER_CREDIT_ADDED",
    active: true,
  },
];
export const ConsentType = {
  GRAIL_PAY: 1,
  FLEX_PAY: 2,
  NMI: 3,
};

export const ConsentSubType = {
  ACH: 1,
  CARD: 2,
};

export const BANKING_BALANCE_VISIBILITY_KEY = "accounting_banking_balance_visibility";

// Server-side Chart-of-Accounts `system_key` values referenced on the client.
// Keep these in one place instead of scattering the raw enum strings.
export const CoaSystemKey = {
  CC_BATCH_DEPOSIT: "CC_BATCH_DEPOSIT",
  INCOME_SALES_RETURNS: "INCOME_SALES_RETURNS",
};

export const JOURNAL_ENTRIES_STATUSES = {
  1: { bg: "#FFF8DD", text: "#FFC700", label: "Pending" },
  2: { bg: "#E8FFF3", text: "#50CD89", label: "Posted" },
  3: { bg: "#FFF5F8", text: "#F1416C", label: "Reversed" },
};

export const TRANSACTION_TYPE_FILTER_OPTIONS = [
  { value: 1, label: "Manual" },
  { value: 2, label: "Invoice" },
  { value: 3, label: "Payment" },
  { value: 4, label: "Bill" },
  { value: 5, label: "Bill payment" },
  { value: 6, label: "Purchase receive" },
  { value: 7, label: "Expense" },
  { value: 8, label: "Balance adjustment" },
  { value: 9, label: "Supplier Return" },
  { value: 10, label: "Bank Deposits" },
  { value: 11, label: "Sale Return" },
  { value: 12, label: "Supplier Payment" },
  { value: 13, label: "Bank Transfer" },
  { value: 14, label: "Opening Balance" },
  { value: 15, label: "Reconciliation" },
  { value: 16, label: "Inventory Adjustment" },
  { value: 17, label: "Transfer" },
  { value: 19, label: "Deposit" },
];



export const salesOptionspaymentSubTypes = {
  OFFLINE: { label: "Offline Payment", value: 4 },
  TYPE_IN: { label: "Key in Credit/Debit Card Payment", value: 5 },
  SCAN: { label: "Paid CC Terminal", value: 6 },
};

export const salesOptionsForChequepaymentSubTypes = {
  OFFLINE: salesOptionspaymentSubTypes.OFFLINE,
  E_CHEQUE: { label: "E-check", value: 8 },
};

export const salesOptionspaymentSubTypesExtended = {
  ...salesOptionspaymentSubTypes,
  APPLE_PAY: { label: "Apple Pay", value: 7 },
};

export const dateFormat = "YYYY-MM-DD";
export const dateFormatForShowOnFrontend = "MM-DD-YYYY";

export const AGING_OVERDUE_PERIOD_OPTIONS = [
  { label: "0-7 days", value: 1 },
  { label: "7-14 days", value: 2 },
  { label: "14-30 days", value: 3 },
  { label: "30-60 days", value: 4 },
  { label: "60-90 days", value: 5 },
  { label: "90+ days", value: 6 },
];

export const adjustment_types = {
  CREDIT: { value: 1, type: "Credit" },
  DEBIT: { value: 2, type: "Debit" },
};

// Balance adjustment lifecycle, mirrors server BalanceAdjustmentStatus.
export const balance_adjustment_status = {
  COMPLETED: { value: 10, type: "Completed" },
  VOID: { value: 20, type: "Voided" },
  UN_PAID: { value: 30, type: "Un Paid" },
  PARTIALLY_PAID: { value: 40, type: "Partially Paid" },
};

//Search Input Delay
export const DELAY = 800;

// Report search: true = tag search with a "Search <field> for:" criteria dropdown (AdvanceFiltersWithTags),
// false = a single debounced input sent as search_key. Kept off for now.
export const ENABLE_REPORT_SEARCH_TAGS = false;

// list table initial filters

export const accountTypePriority = {
  Expenses: 1,
  "Cost of Goods Sold": 1.1,
  "Other Expense": 1.2,
  "Tax Paid Expense": 1.3,
  Income: 2,
  "Other Income": 2.1,
  Assets: 3,
  "Other Asset": 3.1,
  "Other Current Asset": 3.2,
  Cash: 3.3,
  Bank: 3.4,
  "Fixed Asset": 3.5,
  Stock: 3.6,
  "Payment Clearing": 3.7,
  Liabilities: 4,
  "Other Current Liability": 4.1,
  "Credit Card": 4.2,
  "Long Term Liability": 4.3,
  "Other Liability": 4.4,
  "Output Tax": 4.5,
  Equity: 5,
};

export const filterConstants = {
  PAYMENT_RECEIVE: "payment_receive",
  PAYMENT_LOG: "payment_log",
};

export const defaultSorted = [{ dataField: "id", order: "asc" }];

export const initialFilter = {
  sortOrder: "desc", // asc||desc
  sortField: "updated_at",
  pageNumber: 1,
  pageSize: 20,
  searchKey: "",
  customerId: "",
  startDate: "",
  endDate: "",
  orderNo: "",
  user: "",
  statuses: "",
  saleAgentIds: "",
};

export const NO_PREFIX = {
  STOCK_TRANSFER: "ST",
  PURCHASE_ORDER: "PO",
  PURCHASE_RECEIVE: "PR",
  PURCHASE_RETURN: "PR",
  SALE_ORDER: "SO",
};

export const WEIGHT_UNIT = {
  OZ: 1,
  LB: 2,
  KG: 3,
  G: 4,
};
export const WEIGHT_UNIT_EXPORT = {
  1: "OZ",
  2: "LB",
  3: "KG",
  4: "G",
};

export const BOX_SIZE_OPTIONS = {
  SMALL: { value: 'small', label: 'Small' },
  MEDIUM: { value: 'medium', label: 'Medium' },
  LARGE: { value: 'large', label: 'Large' }
};

export const BOX_WEIGHT_UNITS = [
  { value: 'lb', label: 'lb' },
  { value: 'oz', label: 'oz' },
  { value: 'kg', label: 'kg' },
  { value: 'g', label: 'g' }
];

export const BOX_SIZE_ENUM_MAP = {
  1: 'small',
  2: 'medium',
  3: 'large',
  4: 'UNKNOWN'
};

export const WEIGHT_UNIT_ENUM_MAP = {
  1: 'oz',
  2: 'lb',
  3: 'kg',
  4: 'g'
};

// Reverse mappings for sending to backend
export const BOX_SIZE_TO_ENUM = {
  'small': 1,
  'medium': 2,
  'large': 3,
  'UNKNOWN': 4
};

export const WEIGHT_UNIT_TO_ENUM = {
  'oz': 1,
  'lb': 2,
  'kg': 3,
  'g': 4
};


export const CURRENCY_CODE = [
  "AFA",
  "ALL",
  "DZD",
  "AOA",
  "ARS",
  "AMD",
  "AWG",
  "AUD",
  "AZN",
  "BSD",
  "BHD",
  "BDT",
  "BBD",
  "BYR",
  "BEF",
  "BZD",
  "BMD",
  "BTN",
  "BTC",
  "BOB",
  "BAM",
  "BWP",
  "BRL",
  "GBP",
  "BND",
  "BGN",
  "BIF",
  "KHR",
  "CAD",
  "CVE",
  "KYD",
  "XOF",
  "XAF",
  "XPF",
  "CLP",
  "CNY",
  "COP",
  "KMF",
  "CDF",
  "CRC",
  "HRK",
  "CUC",
  "CZK",
  "DKK",
  "DJF",
  "DOP",
  "XCD",
  "EGP",
  "ERN",
  "EEK",
  "ETB",
  "EUR",
  "FKP",
  "FJD",
  "GMD",
  "GEL",
  "DEM",
  "GHS",
  "GIP",
  "GRD",
  "GTQ",
  "GNF",
  "GYD",
  "HTG",
  "HNL",
  "HKD",
  "HUF",
  "ISK",
  "INR",
  "IDR",
  "IRR",
  "IQD",
  "ILS",
  "ITL",
  "JMD",
  "JPY",
  "JOD",
  "KZT",
  "KES",
  "KWD",
  "KGS",
  "LAK",
  "LVL",
  "LBP",
  "LSL",
  "LRD",
  "LYD",
  "LTL",
  "MOP",
  "MKD",
  "MGA",
  "MWK",
  "MYR",
  "MVR",
  "MRO",
  "MUR",
  "MXN",
  "MDL",
  "MNT",
  "MAD",
  "MZM",
  "MMK",
  "NAD",
  "NPR",
  "ANG",
  "TWD",
  "NZD",
  "NIO",
  "NGN",
  "KPW",
  "NOK",
  "OMR",
  "PKR",
  "PAB",
  "PGK",
  "PYG",
  "PEN",
  "PHP",
  "PLN",
  "QAR",
  "RON",
  "RUB",
  "RWF",
  "SVC",
  "WST",
  "SAR",
  "RSD",
  "SCR",
  "SLL",
  "SGD",
  "SKK",
  "SBD",
  "SOS",
  "ZAR",
  "KRW",
  "XDR",
  "LKR",
  "SHP",
  "SDG",
  "SRD",
  "SZL",
  "SEK",
  "CHF",
  "SYP",
  "STD",
  "TJS",
  "TZS",
  "THB",
  "TOP",
  "TTD",
  "TND",
  "TRY",
  "TMT",
  "UGX",
  "UAH",
  "AED",
  "UYU",
  "USD",
  "UZS",
  "VUV",
  "VEF",
  "VND",
  "YER",
  "ZMK",
];

export const MARGIN_TYPE = {
  FIXED: 1,
  PERCENTAGE: 2,
};

export const MARGIN_TYPE_EXPORT = {
  1: "FIXED",
  2: "PERCENTAGE",
};

export const DISTRIBUTE_TYPE = {
  FOR_EACH_PRODUCT: {
    type: "For Each Product",
    value: 1,
  },
  OVERALL_PURCHASE_ORDER: {
    type: "Overall PO",
    value: 2,
  },
};

export const SALE_ORDER_SOURCE = {
  ECOM: {
    name: "Ecom",
    value: 1,
    color: "#E6ECFD",
    textColor: "#0646E9",
  },
  PORTAL: {
    name: "Portal",
    value: 2,
    color: "#F2F2F2",
    textColor: "##333333",
  },
  BOTH: {
    name: "Both",
    value: 3,
    color: "#EAF4F0",
    textColor: "#10B265",
  },
};

export const PAYABLE_TYPE = {
  SUPPLIER: {
    type: "Payable by Supplier",
    value: 1,
  },
  TENANT: {
    type: "Payable by Tenant",
    value: 2,
  },
};

export const PAYABLE_TO_TYPE = {
  SUPPLIER: {
    type: "Payable To Supplier",
    value: 1,
  },
  NOT_SUPPLIER: {
    type: "Not Payable To Tenant",
    value: 2,
  },
};
export const SUPPLIER_MODE_OF_PAYMENT = {
  // CREDIT_DEBIT_CARD: {
  //   value: 3,
  //   type: "Credit/Debit Card",
  // },
  ZELLE_WIRE_TRANSFER: {
    value: 5,
    type: "Zelle/Wire Transfer",
  },
  CASH: {
    value: 1,
    type: "Cash",
  },
  ACH: {
    value: 12,
    type: "ACH",
  },
  CHEQUE: {
    value: 2,
    type: "Cheque",
  },
  MONEY_ORDER: {
    value: 7,
    type: "Money Order",
  },
};
export const VALUE_TYPE = {
  PERCENTAGE: 1,
  FIXED: 2,
};

export const CHARGE_TYPE = {
  CHARGES: {
    type: "Charges",
    value: 1,
  },
  DISCOUNTS: {
    type: "Discounts",
    value: 2,
  },
};

export const TAG_TYPE = {
  1: "Product Label",
  2: "Order Label",
};

export const TAG_STATUS = {
  1: "Active",
  0: "Inactive",
};

export const PRODUCT_DEFAULT_IMAGE = "https://khub-app.s3-accelerate.amazonaws.com/media/product/images/product-coming-soon.png";

export const PRODUCT_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
  DISCONTINUED: 3,
};

export const CELERY_PROGRESS_STATUS = {
  1: {
    id: 1,
    slug: "PUBLISHED",
    name: "Published",
  },
  2: {
    id: 2,
    slug: "STARTED",
    name: "Started",
  },
  3: {
    id: 3,
    slug: "COMPLETED",
    name: "Completed",
  },
  4: {
    id: 4,
    slug: "FAILED",
    name: "Failed",
  },
  5: {
    id: 5,
    slug: "PROGRESS",
    name: "Progress",
  },
};

export const EXPORT_FILE_TYPE = {
  CSV: 1,
  PDF: 2,
  EXCEL: 3,
};

export const CELERY_PROGRESS_STATUS_OBJECT = {
  PUBLISHED: {
    id: 1,
    slug: "PUBLISHED",
    name: "Published",
  },
  STARTED: {
    id: 2,
    slug: "STARTED",
    name: "Started",
  },
  COMPLETED: {
    id: 3,
    slug: "COMPLETED",
    name: "Success",
  },
  FAILED: {
    id: 4,
    slug: "FAILED",
    name: "Failure",
  },
  UNKNOWN: {
    id: 6,
    slug: "UNKNOWN",
    name: "Unknown",
  },
  PROGRESS: {
    id: 5,
    slug: "PROGRESS",
    name: "In Progress",
  },
};

export const CELERY_INTEGER_TASK_ID = {
  1: CELERY_PROGRESS_STATUS_OBJECT.PUBLISHED,
  2: CELERY_PROGRESS_STATUS_OBJECT.STARTED,
  3: CELERY_PROGRESS_STATUS_OBJECT.COMPLETED,
  4: CELERY_PROGRESS_STATUS_OBJECT.FAILED,
  5: CELERY_PROGRESS_STATUS_OBJECT.PROGRESS,
};

export const getCeleryTask = (status) => {
  if (
    [CELERY_PROGRESS_STATUS_OBJECT.PUBLISHED.slug, CELERY_PROGRESS_STATUS_OBJECT.STARTED.slug, CELERY_PROGRESS_STATUS_OBJECT.PROGRESS.slug].includes(status)
  ) {
    return CELERY_PROGRESS_STATUS_OBJECT.PROGRESS.name;
  } else if ([CELERY_PROGRESS_STATUS_OBJECT.FAILED.slug, CELERY_PROGRESS_STATUS_OBJECT.COMPLETED.slug].includes(status)) {
    return CELERY_PROGRESS_STATUS_OBJECT[status].name;
  } else {
    return status;
  }
};

export const BG_TASK_NAME_BG = {
  brand_export: "Brand Export",
  brand_import: "Brand Import",
  product_export: "Product Export",
  product_import: "Product Import",
  category_export: "Category Export",
  category_import: "Category Import",
  export_supplier: "Supplier Export",
  import_supplier: "Supplier Import",
  customer_export: "Customer Export",
  import_customer_v2: "Customer Import",
  assign_product_images: "Assign Product Images",
};
export const notification_block_list = ["webhook_send"];
export const BG_TASK_TYPE = {
  EXPORT: {
    value: 1,
    type: "Export",
  },
  IMPORT: {
    value: 2,
    type: "Import",
  },
  EMAIL: {
    value: 3,
    type: "Email",
  },
  OTHER: {
    value: 4,
    type: "Other",
  },
};

export const PRODUCT_STATUS_EXPORT = {
  1: "ACTIVE",
  2: "INACTIVE",
  3: "DISCONTINUED",
};
export const PRODUCT_ONLINE_STATUS = {
  YES: true,
  NO: false,
};
export const PRODUCT_ONLINE_STATUS_EXPORT = {
  true: "YES",
  false: "NO",
};

export const PRODUCT_MEDIA_KEYS = {
  VIDEO: "video",
  PRIMARY: "primary",
  THUMBNAIL: "thumbnail",
  OTHER: "other",
  DETAILS: "details",
};

export const BASIC_SETTINGS_MEDIA_KEYS = {
  IMAGE: "image",
  PRIMARY: "primary",
  THUMBNAIL: "thumbnail",
  OTHER: "other",
  DETAILS: "details",
};

export const ORDER_RECEIVE_CART_PRODUCT_TYPE = {
  OLD: 1,
  NEW: 2,
  VARIANT: 3,
};

export const PRICE_TYPE_OPTIONS = [
  { label: "Promotion Price", value: "1" },
  { label: "Last Sold Price", value: "2" },
  { label: "Customer Group Price", value: "3" },
  { label: "Customer Tier Price", value: "4" },
];

export const UNIT_OF_MEASUREMENT = {
  COUNT: { name: "Count", value: 10 },
};

export const UNIT_LEVELS = {
  LEVEL_1: { label: "Level 1 Ex: (Piece)", value: 1 },
  LEVEL_2: { label: "Level 2 Ex: (Pack)", value: 2 },
  LEVEL_3: { label: "Level 3 Ex: (Case)", value: 3 },
  LEVEL_4: { label: "Level 4 Ex: (Pallet)", value: 4 },
};

export const UNIT_LEVEL_OPTIONS = Object.values(UNIT_LEVELS);

export const UNIT_VALUE = { PIECE: 1, PACK: 2, CASE: 3, PALLET: 4 };
export const UNIT_KEYS = ["1", "2", "3", "4"];

export const UNIT = {
  PIECE: { name: "Piece", value: UNIT_VALUE.PIECE, subId: null },
  PACK: { name: "Pack", value: UNIT_VALUE.PACK, subType: "piece", subId: 1 },
  CASE: { name: "Case", value: UNIT_VALUE.CASE, subType: "pack", subId: 2 },
  PALLET: { name: "Pallet", value: UNIT_VALUE.PALLET, subType: "case", subId: 3 },
};

export const Units = {
  1: UNIT.PIECE,
  2: UNIT.PACK,
  3: UNIT.CASE,
  4: UNIT.PALLET,
};

export const UNIT_OPTIONS = [UNIT.PIECE, UNIT.PACK, UNIT.CASE, UNIT.PALLET];

/**
 * Label for a packaging tier: the tenant's own Unit Desc when they have written one,
 * otherwise the tier's fixed name.
 *
 * A blank unit_name means "not named by this tenant" — migration 388 restored that
 * distinction by clearing the tier names 252 had seeded — so every place that renders a
 * unit to the user goes through here rather than reading unit_name directly.
 */
export const unitLabel = (unit, unitName) => {
  const described = typeof unitName === "string" ? unitName.trim() : "";
  return described || Units[unit]?.name || "";
};

/**
 * Counting form of `unitLabel`, for suffixes like "10 - Cartons".
 *
 * Only the built-in tier names are pluralised — they are known English words. A tenant's
 * description is returned exactly as typed: it is arbitrary text in any language, and
 * appending "s" turns "box" into "boxs" and "batch" into "batchs".
 */
export const unitLabelPlural = (unit, unitName) => {
  const described = typeof unitName === "string" ? unitName.trim() : "";
  if (described) return described;
  const name = Units[unit]?.name || "";
  return name ? `${name}s` : "";
};

export const TIER_PRICE_LIMIT = 5;

export const MAX_UNITS_ALLOWED = 4;
export const BASE_UNIT_VALUE = 1;
export const LAST_UNIT_INDEX = 3;
export const FIRST_UNIT_INDEX = 0;

export const OPERATIONS = { CREATE: "1", LINK: "2", UPDATE: "3", UNLINK: "4" };

// New Dynamic UNIT constants for custom labels
export const DynamicUNIT = {
  PIECE: { name: "Piece", value: UNIT_VALUE.PIECE, subId: null },
  PACK: { name: "Pack", value: UNIT_VALUE.PACK, subType: "piece", subId: 1 },
  CASE: { name: "Case", value: UNIT_VALUE.CASE, subType: "pack", subId: 2 },
  PALLET: { name: "Pallet", value: UNIT_VALUE.PALLET, subType: "case", subId: 3 },
  CUSTOM: { name: "Custom", value: 99 },
};

export const DynamicUnits = {
  1: DynamicUNIT.PIECE,
  2: DynamicUNIT.PACK,
  3: DynamicUNIT.CASE,
  4: DynamicUNIT.PALLET,
};

export const DynamicUNIT_OPTIONS = [DynamicUNIT.PIECE, DynamicUNIT.PACK, DynamicUNIT.CASE, DynamicUNIT.PALLET];

export const ORDER_RECEIVES_CHANGE_TYPE = {
  COST: "cost",
  MARGIN: "margin",
  MARGIN_TYPE: "margin_type",
  PRICE: "price",
};
export const PAYMENT_TYPE_PURCHASE_ORDER = {
  CASH: {
    value: 1,
    type: "Cash",
    id: "control_01",
  },
  ACH: {
    value: 12,
    type: "ACH",
    id: "control_10",
  },
  CHEQUE: {
    value: 2,
    type: "Cheque",
    id: "control_02",
  },
  CREDIT_DEBIT_CARD: {
    value: 3,
    type: "Credit/Debit Card",
    id: "control_03",
  },
  CASH_ON_DELIVERY: {
    value: 4,
    type: "Cash On Delivery",
    id: "control_04",
  },
  ZELLE_WIRE_TRANSFER: {
    value: 5,
    type: "Zelle Wire Transfer",
    id: "control_05",
  },
  ON_ACCOUNT: {
    value: 6,
    type: "On Account",
    id: "control_06",
  },
  BANK_TRANSFER_IBFT: {
    value: 7,
    type: "Money Order",
    id: "control_07",
  },
  CUSTOMER_CREDIT_USED: {
    value: 8,
    type: "Customer Credit Used",
    id: "control_08",
  },
  CUSTOMER_CREDIT_ADDED: {
    value: 9,
    type: "Customer Credit Added",
    id: "control_09",
  },
  SUPPLIER_OVERPAYMENT_USED: {
    value: 10,
    type: "Supplier Credit Used",
    id: "control_09",
  },
  SUPPLIER_OVERPAYMENT_ADDED: {
    value: 11,
    type: "Supplier Credit Added",
    id: "control_10",
  },
};

export const PURCHASE_ORDER_STATUS = {
  RETURNED: {
    value: 1,
    type2: "Returned",
    type: <FormattedMessage id="Returned" defaultMessage="Returned" />,
    color: "#95a5a6", //  #f1c40f
  },

  IN_PROGRESS: {
    value: 2,
    type2: "In Progress",
    type: <FormattedMessage id="In Progress" defaultMessage="In Progress" />,
    color: "#117a8b",
  },

  PARTIALLY_RECEIVED: {
    value: 4,
    type2: "Partially Received",
    type: <FormattedMessage id="Partially Received" defaultMessage="Partially Received" />,
    color: "#2980b9",
  },
  RECEIVED: {
    value: 5,
    type2: "Received",
    type: <FormattedMessage id="Received" defaultMessage="Received" />,
    color: "#28a745",
  },
  CANCELLED: {
    value: 3,
    type2: "Canceled",
    type: <FormattedMessage id="Canceled" defaultMessage="Canceled" />,
    color: "#c0392b",
  },
  CLOSED: {
    value: 6,
    type2: "Completed",
    type: <FormattedMessage id="Completed" defaultMessage="Completed" />,
    color: "#95a5a6",
  },
  PARTIAL_RETURNED: {
    value: 7,
    type2: "Partially Returned",
    type: <FormattedMessage id="Partially Returned" defaultMessage="Partially Returned" />,
    color: "#95a5a6", //  #f1c40f
  },
  PARKED: {
    value: 8,
    type2: "Parked",
    type: <FormattedMessage id="Parked" defaultMessage="Parked" />,
    color: "#95a5a6", //  #f1c40f
  },
};

export const PURCHASE_RETURN_STATUS = {
  PENDING: {
    value: 1,
    type2: "Pending",
    type: <FormattedMessage id="Pending" defaultMessage="Pending" />,
    class: "label-light-warning",
    color: "#f1c40f",
  },
  IN_PROGRESS: {
    value: 2,
    type2: "In Progress",
    type: <FormattedMessage id="In Progress" defaultMessage="In Progress" />,
    class: "label-light-info",
    color: "#117a8b",
  },
  REJECTED: {
    value: 3,
    type2: "Rejected",
    type: <FormattedMessage id="Rejected" defaultMessage="Rejected" />,
    class: "label-light-danger",
    color: "#c0392b",
  },
  COMPLETED: {
    value: 4,
    type2: "Returned",
    type: <FormattedMessage id="Returned" defaultMessage="Returned" />,
    class: "label-light-success",
    color: "#95a5a6",
  },
  VOID: {
    value: 5,
    type2: "Void",
    type: <FormattedMessage id="Void" defaultMessage="Void" />,
    class: "label-light-success",
    color: "#f5dcdc",
  },
   PARKED: {
    value: 6,
    type2: "Parked",
    type: <FormattedMessage id="Parked" defaultMessage="Parked" />,
    class: "label-light-success",
    color: "#117a8b",
  },
};

export const PURCHASE_RECEIVE_STATUS = {
  PENDING: {
    value: 1,
    type2: "Pending",
    type: <FormattedMessage id="Pending" defaultMessage="Pending" />,
    color: "#f1c40f",
  },
  IN_PROGRESS: {
    value: 2,
    type2: "In Progress",
    type: <FormattedMessage id="In Progress" defaultMessage="In Progress" />,
    color: "#117a8b",
  },
  ON_HOLD: {
    value: 3,
    type2: "On Hold",
    type: <FormattedMessage id="On Hold" defaultMessage="On Hold" />,
    color: "#f368e0",
  },
  REJECTED: {
    value: 4,
    type2: "Rejected",
    type: <FormattedMessage id="Rejected" defaultMessage="Rejected" />,
    color: "#c0392b",
  },
  COMPLETED: {
    value: 5,
    type2: "Completed",
    type: <FormattedMessage id="Completed" defaultMessage="Completed" />,
    color: "#28a745",
  },
  VOID: {
    value: 6,
    type2: "Void",
    type: <FormattedMessage id="Void" defaultMessage="Void" />,
    color: "#f5dcdc",
  },
  RECEIVED: {
    value: 7,
    type2: "Received",
    type: <FormattedMessage id="Received" defaultMessage="Received" />,
    color: "#28a745",
  },
};

export const SUPPLIER_PURCHASE_RECEIVED = {
  PENDING: {
    value: 1,
    type2: "Pending",
    type: <FormattedMessage id="Pending" defaultMessage="Pending" />,
    color: "#f1c40f",
  },
  IN_PROGRESS: {
    value: 2,
    type2: "In Progress",
    type: <FormattedMessage id="In Progress" defaultMessage="In Progress" />,
    color: "#117a8b",
  },
  ON_HOLD: {
    value: 3,
    type2: "On Hold",
    type: <FormattedMessage id="On Hold" defaultMessage="On Hold" />,
    color: "#c0392b",
  },
  REJECTED: {
    value: 4,
    type2: "In Progress",
    type: <FormattedMessage id="Rejected" defaultMessage="Rejected" />,
    color: "#c0392b",
  },
  COMPLETED: {
    value: 5,
    type2: "Completed",
    type: <FormattedMessage id="Completed" defaultMessage="Completed" />,
    color: "#28a745",
  },
  VOID: {
    value: 6,
    type2: "Void",
    type: <FormattedMessage id="Void" defaultMessage="Void" />,
    color: "#c0392b",
  },
  RECEIVED: {
    value: 7,
    type2: "Received",
    type: <FormattedMessage id="Received" defaultMessage="Received" />,
    color: "#28a745",
  },
  CANCELLED: {
    value: 8,
    type2: "Canceled",
    type: <FormattedMessage id="Canceled" defaultMessage="Canceled" />,
    color: "#c0392b",
  },
};

export const PURCHASE_ORDER_PATH_INDICES = {
  ORDER_ID_INDEX: 4,
  RECEIVE_ID_INDEX: 6,
  RETURN_ID_INDEX: 6,
  EDIT_INDEX: 7,
  INDEPENDANT_RETURN_INDEX: 3,
  INDEPENDANT_RETURN_ID_INDEX: 4,
  INDEPENDANT_RETURN_EDIT_INDEX: 5,
  INDEPENDENT_RETURN_CLONE_INDEX: 5,
};

export const PURCHASE_RETURN_PATHS = {
  INDEPENDANT_RETURN_PATH: "/inventory/purchase/return",
  PURCHASE_ORDER_RETURN_PATH: "/inventory/purchase/order/return",
};

export const SUPPLIER_PURCHASE_RECEIVED_OBJ = {
  1: SUPPLIER_PURCHASE_RECEIVED.PENDING,
  2: SUPPLIER_PURCHASE_RECEIVED.IN_PROGRESS,
  3: SUPPLIER_PURCHASE_RECEIVED.ON_HOLD,
  4: SUPPLIER_PURCHASE_RECEIVED.REJECTED,
  5: SUPPLIER_PURCHASE_RECEIVED.COMPLETED,
  6: SUPPLIER_PURCHASE_RECEIVED.VOID,
  7: SUPPLIER_PURCHASE_RECEIVED.RECEIVED,
  8: SUPPLIER_PURCHASE_RECEIVED.CANCELLED,
};

export const STOCK_TRANSFER_STATUS = {
  IN_PROGRESS: {
    value: 1,
    type2: "Initiate Transfer",
    type: <FormattedMessage id="In Progress" defaultMessage="In Progress" />,
    color: "#FFFFFF",
    style: {
      backgroundColor: "#4A90E2",
    },
  },
  ON_HOLD: {
    value: 2,
    type2: "Park",
    type: <FormattedMessage id="Parked" defaultMessage="Parked" />,
    color: "#FFFFFF",
    style: {
      backgroundColor: "#808080",
    },
  },
  REJECTED: {
    value: 3,
    type2: "Cancel",
    type: <FormattedMessage id="Canceled" defaultMessage="Canceled" />,
    color: "#FFFFFF",
    style: {
      backgroundColor: "#E24A4A",
    },
  },
  CLOSED: {
    value: 4,
    type2: "Mark as Transferred",
    type: <FormattedMessage id="Completed" defaultMessage="Completed" />,
    color: "#FFFFFF",
    style: {
      backgroundColor: "#10B265",
    },
  },
};

export const STOCK_TRANSFER_OBJ = {
  1: STOCK_TRANSFER_STATUS.IN_PROGRESS,
  2: STOCK_TRANSFER_STATUS.ON_HOLD,
  3: STOCK_TRANSFER_STATUS.REJECTED,
  4: STOCK_TRANSFER_STATUS.CLOSED,
};

export const PURCHASE_RECEIVE_PAYMENT_TYPE = {
  WIRETRANSFER: 5,
  CHEQUE: 2,
  CASH: 1,
};

// A supplier can pay back a purchase return in cash and/or cheque (partial allowed).
export const PURCHASE_RETURN_PAYMENT_TYPE = {
  CASH: 1,
  CHEQUE: 2,
};

export const LISTING_TYPE = "admin_panel";

export const SALE_STOCK_CHANNELS_LISTING_SUB_TYPE = "Inventory.SaleStockChannels.Listing.Column";
export const STOCK_ALERT_LISTING_SUB_TYPE = "Inventory.StockAlert.Listing.Column";
export const STOCK_TRANSFER_LISTING_SUB_TYPE = "Inventory.StockTransfer.Listing.Column";
export const SUPPLIER_PAYMENT_LISTING_SUB_TYPE = "Inventory.PaymentHistory.Listing.Column";

export const SIZE_PER_PAGE_LIST = [
  { text: "20", value: 20 },
  { text: "50", value: 50 },
  { text: "100", value: 100 },
];

// ─── ShipEngine Weight Unit Mapping ───
export const SHIPENGINE_WEIGHT_UNIT_MAP = {
  [WEIGHT_UNIT.OZ]: "ounce",
  [WEIGHT_UNIT.LB]: "pound",
  [WEIGHT_UNIT.KG]: "pound",
  [WEIGHT_UNIT.G]: "ounce",
};

// ─── Dimension Unit Constants ───
export const DIMENSION_UNIT = {
  INCH: "inch",
  CENTIMETER: "centimeter",
};

export const DIMENSION_UNIT_OPTIONS = [
  { value: "Inches", label: "Inches", shipengineUnit: DIMENSION_UNIT.INCH },
  { value: "Centimeters", label: "Centimeters", shipengineUnit: DIMENSION_UNIT.CENTIMETER },
];

// ─── ShipStation Label Status Config ───
export const SS_LABEL_STATUS = {
  PROCESSING: "processing",
  COMPLETED: "completed",
  ERROR: "error",
  VOIDED: "voided",
};

export const SS_LABEL_STATUS_CONFIG = {
  [SS_LABEL_STATUS.PROCESSING]: { className: "ss-badge ss-badge--orange", label: "Processing" },
  [SS_LABEL_STATUS.COMPLETED]:  { className: "ss-badge ss-badge--green",  label: "Active" },
  [SS_LABEL_STATUS.ERROR]:      { className: "ss-badge ss-badge--red",    label: "Error" },
  [SS_LABEL_STATUS.VOIDED]:     { className: "ss-badge ss-badge--gray",   label: "Voided" },
};

// ─── ShipStation Tracking Status Config ───
export const SS_TRACKING_STATUS = {
  UNKNOWN: "unknown",
  NOT_YET_IN_SYSTEM: "not_yet_in_system",
  ACCEPTED: "accepted",
  IN_TRANSIT: "in_transit",
  ATTEMPTED: "attempted",
  DELIVERED: "delivered",
  DELIVERED_TO_SERVICE_POINT: "delivered_to_service_point",
  EXCEPTION: "exception",
};

export const SS_TRACKING_STATUS_CONFIG = {
  [SS_TRACKING_STATUS.UNKNOWN]:            { className: "ss-badge ss-badge--gray",   label: "Awaiting Shipment",   statusCode: "UN" },
  [SS_TRACKING_STATUS.NOT_YET_IN_SYSTEM]:  { className: "ss-badge ss-badge--gray",   label: "Not Yet Scanned",     statusCode: "NY" },
  [SS_TRACKING_STATUS.ACCEPTED]:           { className: "ss-badge ss-badge--blue",   label: "Accepted",            statusCode: "AC" },
  [SS_TRACKING_STATUS.IN_TRANSIT]:         { className: "ss-badge ss-badge--blue",   label: "In Transit",          statusCode: "IT" },
  [SS_TRACKING_STATUS.ATTEMPTED]:          { className: "ss-badge ss-badge--yellow", label: "Delivery Attempted",  statusCode: "AT" },
  [SS_TRACKING_STATUS.DELIVERED]:          { className: "ss-badge ss-badge--green",  label: "Delivered",           statusCode: "DE" },
  [SS_TRACKING_STATUS.DELIVERED_TO_SERVICE_POINT]: { className: "ss-badge ss-badge--green", label: "Delivered to Pickup Point", statusCode: "SP" },
  [SS_TRACKING_STATUS.EXCEPTION]:          { className: "ss-badge ss-badge--red",    label: "Exception",           statusCode: "EX" },
};

export const SS_STATUS_CODE_MAP = {
  UN: SS_TRACKING_STATUS.UNKNOWN,
  NY: SS_TRACKING_STATUS.NOT_YET_IN_SYSTEM,
  AC: SS_TRACKING_STATUS.ACCEPTED,
  IT: SS_TRACKING_STATUS.IN_TRANSIT,
  AT: SS_TRACKING_STATUS.ATTEMPTED,
  DE: SS_TRACKING_STATUS.DELIVERED,
  SP: SS_TRACKING_STATUS.DELIVERED_TO_SERVICE_POINT,
  EX: SS_TRACKING_STATUS.EXCEPTION,
};

export const SS_VOIDABLE_TRACKING_STATUSES = [
  SS_TRACKING_STATUS.UNKNOWN,
  SS_TRACKING_STATUS.NOT_YET_IN_SYSTEM,
];

export const SHIPMENT_MODE = {
  PARCEL: "parcel",
  LTL: "ltl",
};

export const PARCEL_WEIGHT_LIMIT_LBS = 150;

export const BOX_WEIGHT_CONVERSIONS = {
  kg_to_g: 1000,
  g_to_kg: 0.001,
  lb_to_oz: 16,
  oz_to_lb: 0.0625,
  kg_to_lb: 2.20462,
  lb_to_kg: 0.453592,
  g_to_oz: 0.035274,
  oz_to_g: 28.3495,
};

export const BOX_STATUS = {
  OPEN: 'open',
  CLOSED: 'closed'
};

// ============================================================================
// Fulfillment Action Constants
// ============================================================================






export const SHIPPING_TYPE = {
  PICKUP: {
    value: 1,
    type: "Pickup",
    bgColor: "#E24A4A",
    color: "#fff",
  },
  DELIVERY: {
    value: 2,
    type: "Shipping",
    icon: <i className="fas fa-shipping-fast" style={{ color: "#ea1e51" }} />,
  },
  DropOFF: {
    value: 3,
    type: "Dropoff",
  },
};

export const INVOICE_STATUS = {
  DUE: {
    value: 1,
    name: "Due",
    color: "#ffbbbb",
    texColor: "",
  },
  UN_PAID: {
    value: 2,
    name: "Un Paid",
    color: "#E24A4A",
    texColor: "#fff",
  },
  PAID: {
    value: 3,
    name: "Paid",
    color: "#10B265",
    texColor: "#fff",
  },
  PARTIALLY_PAID: {
    value: 5,
    name: "Partially Paid",
    color: "#7ED957",
    texColor: "#333333",
  },
  FULLY_REFUNDED: {
    value: 6,
    name: "Canceled",
    type: <FormattedMessage id="Canceled" defaultMessage="Canceled" />,
    color: "#c0392b",
  },
  VOID: {
    value: 8,
    name: "Void",
    color: "#808080",
    texColor: "#fff",
  },
  DRAFT: {
    value: 9,
    name: "Draft",
    color: "#E2964A",
    texColor: "#fff",
  },
};

export const INVOICE_STATUS_SALE_HISTORY = {
  DUE: {
    value: 1,
    name: "Due",
    color: "#ffbbbb",
    texColor: "",
  },
  UN_PAID: {
    value: 2,
    name: "Un Paid",
    color: "#E24A4A",
    texColor: "#fff",
  },
  PAID: {
    value: 3,
    name: "Paid",
    color: "#10B265",
    texColor: "#fff",
  },
  PARTIALLY_PAID: {
    value: 5,
    name: "Partially Paid",
    color: "#7ED957",
    texColor: "#333333",
  },
  FULLY_REFUNDED: {
    value: 6,
    name: "Refunded",
    type: "Refunded",
    color: "#e90216",
  },
  VOID: {
    value: 8,
    name: "Void",
    color: "#808080",
    texColor: "#fff",
  },
  DRAFT: {
    value: 9,
    name: "Draft",
    color: "#E2964A",
    texColor: "#fff",
  },
};

export const BILL_STATUS = {
  UN_PAID: {
    value: 1,
    name: "Un Paid",
    color: "#E24A4A",
    textColor: "#fff",
  },
  PAID: {
    value: 3,
    name: "Paid",
    color: "#10B265",
    textColor: "#fff",
  },
  PARTIALLY_PAID: {
    value: 2,
    name: "Partially Paid",
    color: "#7ED957",
    textColor: "#333333",
  },
  VOID: {
    value: 4,
    name: "Void",
    color: "#808080",
    textColor: "#fff",
  },
};

export const BILL_PAYMENT_STATUS = {
  PENDING: {
    value: 1,
    name: "Pending",
    color: "#d8d833",
    textColor: "#000",
  },
  PAID: {
    value: 2,
    name: "Paid",
    color: "#10B265",
    textColor: "#fff",
  },
  VOID: {
    value: 5,
    name: "Void",
    color: "#808080",
    textColor: "#fff",
  },
};

export const EXPENSE_STATUS = {
  UN_PAID: {
    value: 1,
    name: "Un Paid",
    color: "#E24A4A",
    textColor: "#fff",
  },
  VOID: {
    value: 2,
    name: "Void",
    color: "#808080",
    textColor: "#fff",
  },
};

export const SORTED_INVOICE_STATUS = Object.values(INVOICE_STATUS).sort((a, b) => a.name?.localeCompare(b.name));
export const PAYMENT_STATUS = {
  PENDING: {
    value: 1,
    name: "Pending",
    color: "#d8d833",
  },
  PAID: {
    value: 2,
    name: "Paid",
    color: "#2db83d",
  },
  FULLY_REFUNDED: {
    value: 3,
    name: "Fully Refunded",
    color: "#c7ecc7",
  },
  PARTIALLY_REFUNDED: {
    value: 4,
    name: "Partially Refunded",
    color: "#d1f0ff",
  },
  VOID: {
    value: 5,
    name: "Void",
    color: "#E24A4A",
  },
  FAILED: {
    value: 6,
    name: "Failed",
    color: "#ef3c6c",
  },
  UNKNOWN: {
    value: 7,
    name: "Unknown",
    color: "#f5dcdc",
  },
  RETURNED: {
    value: 8,
    name: "Returned",
    color: "#95a5a6",
  },
};
// Todo: Need to sync all constants convention
export const SALE_SHIPPING_TYPE = {
  PICKUP: {
    value: 1,
    name: "Pickup",
  },
  DELIVERY: {
    value: 2,
    name: "Delivery",
  },
  DropOFF: {
    value: 3,
    name: "Drop off",
  },
};

export const SALE_TAX_TYPE = {
  PERCENTAGE: {
    value: 1,
    type: "%",
  },
  FIXED: {
    value: 2,
    type: "$",
  },
};

export const ACTIVITY_TYPE = {
  SALE_ORDER: {
    value: 1,
    type: "Sale Order",
  },
  SALE_RETURN: {
    value: 2,
    type: "Sale Return",
  },
  PAYMENT: {
    value: 3,
    type: "Payment",
  },
  REFUND: {
    value: 4,
    type: "Refund",
  },
  STARTING: {
    value: 5,
    type: "Starting",
  },
  SALE_ORDER_VOID: {
    value: 6,
    type: "Sale order void",
  },
  SALE_RETURN_VOID: {
    value: 7,
    type: "Sale return void",
  },
  ACCOUNT_RECHARGE: {
    value: 8,
    type: " Account Recharge",
  },
  BALANCE_ADJUSTMENT: {
    value: 9,
    type: " Balance Adjustment",
  },
  PAYMENT_VOID: {
    value: 10,
    type: " Payment Void",
  },
  SALE_ORDER_EDIT: {
    value: 11,
    type: " Sale Order Edit",
  },
  PAYMENT_FAILED: {
    value: 12,
    type: "Payment Failed",
  },
  PAYMENT_RETURNED: {
    value: 13,
    type: "Payment Returned",
  },
  WALLET_ADDED: {
    value: 14,
    type: "Wallet Added",
  },
  WALLET_USED: {
    value: 15,
    type: "Wallet Used",
  },
  VOID_ADD_TO_CREDIT: {
    value: 16,
    type: "Add Credit Voided",
  },
  VOID_USE_CREDIT: {
    value: 17,
    type: "Used Credit Voided",
  },
  EDIT_USE_CREDIT: {
    value: 18,
    type: "Used Credit Edited",
  },
  BALANCE_ADJUSTMENT_VOID: {
    value: 19,
    type: "Balance Adjustment Void",
  },
  // Synthetic, server-fabricated row prepended to the top of the simplified
  // ledger carrying the customer's current wallet balance. No Ledger row of this
  // type exists in the DB.
  WALLET_ADJUSTMENT: {
    value: 20,
    type: "Wallet Adjustment",
  },
};

export const GENERAL_TAX_NAME_LENGTH = 10;
export const defaultTaxValue = 0.001;

export const SUPPLIER_ACTIVITY_TYPE = {
  PURCHASE_RECEIVE: {
    value: 1,
    type: "Purchase Receive",
  },
  PURCHASE_RETURN: {
    value: 2,
    type: "Purchase Return",
  },
  PAYMENT: {
    value: 3,
    type: "Payment",
  },
  REFUND: {
    value: 4,
    type: "Refund",
  },
  STARTING: {
    value: 5,
    type: "Starting",
  },
  PURCHASE_ORDER_VOID: {
    value: 6,
    type: "Purchase Order Void",
  },
  PURCHASE_RETURN_VOID: {
    value: 7,
    type: "Purchase Return Void",
  },
  ACCOUNT_RECHARGE: {
    value: 8,
    type: "Account Recharge",
  },
  BALANCE_ADJUSTMENT: {
    value: 9,
    type: "Balance Adjustment",
  },
  PAYMENT_VOID: {
    value: 10,
    type: " Payment Void",
  },
  PURCHASE_RECEIVE_EDIT: {
    value: 11,
    type: "Purchase Receive Edit",
  },
  PURCHASE_RETURN_EDIT: {
    value: 12,
    type: "Purchase Return Edit",
  },
  PURCHASE_RECEIVE_VOID: {
    value: 13,
    type: "Purchase Receive Void",
  },
  BILL: {
    value: 14,
    type: "Bill",
  },
  BILL_EDIT: {
    value: 15,
    type: "Bill Edit",
  },
  BILL_VOID: {
    value: 16,
    type: "Bill Void",
  },
  PAYMENT_FAILED: {
    value: 17,
    type: "Payment Failed",
  },
  PAYMENT_RETURNED: {
    value: 18,
    type: "Payment Returned",
  },
  WALLET_ADDED: {
    value: 19,
    type: "Wallet Added",
  },
  WALLET_USED: {
    value: 20,
    type: "Wallet Used",
  },
  VOID_ADD_TO_CREDIT: {
    value: 21,
    type: "Add Credit Voided",
  },
  VOID_USE_CREDIT: {
    value: 22,
    type: "Used Credit Voided",
  },
  EDIT_USE_CREDIT: {
    value: 23,
    type: "Used Credit Edited",
  },
  // Synthetic: fabricated on read for the top wallet-balance row of the
  // simplified supplier ledger (note: the customer enum uses 20 for this).
  WALLET_ADJUSTMENT: {
    value: 24,
    type: "Wallet Adjustment",
  },
  BALANCE_ADJUSTMENT_VOID: {
    value: 25,
    type: "Balance Adjustment Void",
  },
};

export const MODE_OF_PAYMENTS = {
  CASH: {
    value: 1,
    type: "Cash",
  },
  CHEQUE: {
    value: 2,
    type: "Cheque",
  },
  CREDIT_DEBIT: {
    value: 3,
    type: "Credit Debit",
  },
  WIRE_TRANSFER: {
    value: 5,
    type: "Wire Transfer",
  },
  BANK_TRANSFER: {
    value: 7,
    type: "Money Order",
  },
  GRAIL_PAY: {
    value: 12,
    type: "Ach",
  },
};

export const SALE_TYPE = {
  SALE_ORDER: {
    value: 1,
    type: true,
    name: "Sale Order",
  },
  SALE_RETURN: {
    value: 2,
    type: false,
    name: "Sale Return",
  },
};

export const SALE_TYPE_OBJ = {
  1: SALE_TYPE.SALE_ORDER,
  2: SALE_TYPE.SALE_RETURN,
};

export const POST_DATED_PAYMENT_METHODS = [
  { label: "ACH (Standard)", value: "ach_standard" },
  { label: "ACH (Sameday)", value: "ach_sameday" },
  { label: "Cheque (E-check)", value: "cheque_echeck" },
  { label: "Cheque (Offline Payment)", value: "cheque_offline" },
];

// Pre Dated Payments covers every real payment type, not just cheque/ACH. Labels match
// the server's PREDATED_PAYMENT_METHOD_LABELS so the applied-filters chip and the
// export's "Filters Applied" header read the same.
export const PRE_DATED_PAYMENT_METHODS = [
  { label: "ACH (Standard)", value: "ach_standard" },
  { label: "ACH (Sameday)", value: "ach_sameday" },
  { label: "Cheque (E-Check)", value: "cheque_echeck" },
  { label: "Cheque (Offline Payment)", value: "cheque_offline" },
  { label: "Cash", value: "cash" },
  { label: "Credit/Debit Card", value: "card" },
  { label: "Wire Transfer", value: "wire_transfer" },
  { label: "Money Order", value: "money_order" },
];

export const DATE_CRITERIA = [
  { label: "Schedule Date", value: "schedule_date" },
  { label: "Activity Date", value: "activity_date" },
];

export const PAYMENT_TYPE = [
  {
    value: 3,
    // type: <FormattedMessage id="Credit/Debit Card" defaultMessage="Credit/Debit Card" />,
    type2: "Credit/Debit Card",
    id: "control_03",
    name: "CREDIT_DEBIT_CARD",
    active: true,
  },
  {
    value: 12,
    // type: <FormattedMessage id="Ach" defaultMessage="Ach" />,
    type2: "ACH",
    id: "control_01",
    name: "ACH",
    active: true,
  },
  {
    value: 1,
    // type: <FormattedMessage id="Cash" defaultMessage="Cash" />,
    type2: "Cash",
    id: "control_01",
    name: "CASH",
    active: true,
  },
  {
    value: 2,
    // type: <FormattedMessage id="Cheque" defaultMessage="Cheque" />,
    type2: "Cheque",
    id: "control_02",
    name: "CHEQUE",
    active: true,
  },
  {
    value: 4,
    // type: <FormattedMessage id="Cash On Delivery" defaultMessage="Cash On Delivery" />,
    type2: "Cash On Delivery",
    id: "control_04",
    name: "CASH_ON_DELIVERY",
    active: true,
  },
  {
    value: 5,
    // type: <FormattedMessage id="Cash On Delivery" defaultMessage="Cash On Delivery" />,
    type2: "Zelle Wire Transfer",
    id: "control_05",
    name: "ZELLE_WIRE_TRANSFER",
    active: true,
  },
  {
    value: 6,
    // type: <FormattedMessage id="On Account" defaultMessage="On Account" />,
    type2: "On Account",
    id: "control_06",
    name: "ON_ACCOUNT",
    active: true,
  },
  {
    value: 7,
    // type: <FormattedMessage id="Bank Transfer - IBFT" defaultMessage="Bank Transfer - IBFT" />,
    type2: "Money Order",
    id: "control_07",
    name: "Money Order",
    active: true,
  },
  {
    value: 8,
    // type: <FormattedMessage id="Customer Credit Used" defaultMessage="Customer Credit Used" />,
    type2: "Customer Credit Used",
    id: "control_08",
    name: "CUSTOMER_CREDIT_USED",
    active: true,
  },
  {
    value: 9,
    // type: <FormattedMessage id="Customer Credit Added" defaultMessage="Customer Credit Added" />,
    type2: "Customer Credit Added",
    id: "control_09",
    name: "CUSTOMER_CREDIT_ADDED",
    active: true,
  },
];

export const GrailPaySpeed = {
  STANDARD: "standard",
  SAME_DAY: "sameday",
};

export const ScheduleTaskStatus = {
  1: "Pending",
  2: "Completed",
  3: "Failed",
};

export const PAYMENT_TYPE_SALE_ORDER_OBJ = () => {
  return Object.values(PAYMENT_TYPE_SALE_ORDER).reduce((acc, item) => {
    acc[item.value] = item;
    return acc;
  }, {});
};

export const PAYMENT_TYPE_SALE_ORDER = {
  CASH: {
    value: 1,
    type: "Cash",
    id: "control_01",
  },
  CHEQUE: {
    value: 2,
    type: "Cheque",
    id: "control_02",
  },
  CREDIT_DEBIT_CARD: {
    value: 3,
    type: "Credit/Debit Card",
    id: "control_03",
  },
  CASH_ON_DELIVERY: {
    value: 4,
    type: "Cash On Delivery",
    id: "control_04",
  },
  ZELLE_WIRE_TRANSFER: {
    value: 5,
    type: "Zelle Wire Transfer",
    id: "control_05",
  },
  ON_ACCOUNT: {
    value: 6,
    type: "On Account",
    id: "control_06",
  },
  BANK_TRANSFER_IBFT: {
    value: 7,
    type: "Money Order",
    id: "control_07",
  },
  CUSTOMER_CREDIT_USED: {
    value: 8,
    type: "Wallet",
    id: "control_08",
  },
  CUSTOMER_CREDIT_ADDED: {
    value: 9,
    type: "Wallet",
    id: "control_09",
  },
  ACH: {
    value: 12,
    type: "ACH",
    id: "control_10",
  },
  COLLECTED_PAYMENTS: {
    value: 14,
    type: "Collected Payments",
    id: "control_14",
  }
};

// not visible to user, used for internal mapping of payment types in sale order,
// as some payment types are shared between sale and purchase orders but with different values or labels.
export const PAYMENT_TYPE_SALE_ORDER_OMITTED = new Set([
  PAYMENT_TYPE_SALE_ORDER.CUSTOMER_CREDIT_USED.value,
]);

// Customer-facing subset of the backend PaymentType enum, used for the "Preferred Payment Method"
// picker on Customer/Sale Order. Excludes internal-only values (wallet, overpayment) and the unused
// CASH_ON_DELIVERY, matching what a customer can realistically be asked to prefer.
export const PREFERRED_PAYMENT_METHOD = {
  ACH: { name: "ACH", value: 12 },
  CASH: { value: 1, name: "Cash" },
  CHEQUE: { value: 2, name: "Cheque" },
  CREDIT_DEBIT_GATEWAY: { value: 3, name: "Credit/Debit Card" },
  WIRE_TRANSFER: { value: 5, name: "Zelle/Wire Transfer" },
  ON_ACCOUNT: { value: 6, name: "On Account" },
  MONEY_ORDER: { value: 7, name: "Money Order" },
};

export const PAYMENT_CATEGORY = {
  SALE_RECEIPT: {
    value: 1,
    type2: "Payment Received",
    type: <FormattedMessage id="Payment Received" defaultMessage="Payment Received" />,
    purchaseLabel: "Payment Received",
  },
  SALE_RECEIPT_RETURN: {
    value: 2,
    type2: "Receipt Returned",
    type: <FormattedMessage id="Receipt Returned" defaultMessage="Receipt Returned" />,
    purchaseLabel: "Payment Returned",
  },
  PURCHASE_PAYMENT: {
    value: 3,
    type2: "Paid",
    type: <FormattedMessage id="Paid" defaultMessage="Paid" />,
    purchaseLabel: "Payment Paid",
  },
  PURCHASE_PAYMENT_RETURN: {
    value: 4,
    type2: "Payment Returned",
    type: <FormattedMessage id="Payment Returned" defaultMessage="Payment Returned" />,
    purchaseLabel: "Payment Returned",
  },
  MUTUAL_PAYMENT: {
    value: 5,
    type2: "Mutual Payment",
    type: <FormattedMessage id="Mutual Payment" defaultMessage="Mutual Payment" />,
    purchaseLabel: "Mutual Payment",
  },
  ACCOUNT_RECHARGE: {
    value: 6,
    type2: "Account Recharge",
    type: <FormattedMessage id="Account Recharge" defaultMessage="Account Recharge" />,
    purchaseLabel: "Account Recharge",
  },
};
export const PAYMENT_CATEGORY_PAYMENT_RECEIVED = {
  SALE_RECEIPT: {
    // MUTUAL_PAYMENT (value 5) is now considered a payment received category and included here,
    // to reflect updated business logic that treats mutual payments as received payments.
    value: "1,5,6",
    type2: "Payment Received",
    type: <FormattedMessage id="Payment Received" defaultMessage="Payment Received" />,
  },
  SALE_RECEIPT_RETURN: {
    value: 2,
    type2: "Payment Refunded",
    type: <FormattedMessage id="Payment Refunded" defaultMessage="Payment Refunded" />,
  },
  // ACCOUNT_RECHARGE: {
  //   value: 6,
  //   type2: "Account Recharge",
  //   type: <FormattedMessage id="Account Recharge" defaultMessage="Account Recharge" />,
  // },
  // MUTUAL_PAYMENT: {
  //   value: 5,
  //   type2: "Mutual Payment",
  //   type: <FormattedMessage id="Mutual Payment" defaultMessage="Mutual Payment" />,
  // },
};

export const SUPPLIER_PAYMENT_CATEGORY_PAYMENT_RECEIVED = {
  SALE_RECEIPT: {
    value: "3,6,5",
    type2: "Payment Received",
    type: <FormattedMessage id="Payment Received" defaultMessage="Payment Received" />,
  },
  SALE_RECEIPT_RETURN: {
    value: 4,
    type2: "Payment Refunded",
    type: <FormattedMessage id="Payment Refunded" defaultMessage="Payment Refunded" />,
  },
  ACCOUNT_RECHARGE: {
    value: 6,
    type2: "Account Recharge",
    type: <FormattedMessage id="Account Recharge" defaultMessage="Account Recharge" />,
  },
  MUTUAL_PAYMENT: {
    value: 5,
    type2: "Mutual Payment",
    type: <FormattedMessage id="Mutual Payment" defaultMessage="Mutual Payment" />,
  },
};

export const ORDER_TYPE = {
  WALK_IN: {
    value: 1,
    type: "Walk In",
  },
  PHONE: {
    value: 2,
    type: "Phone",
  },
  ONLINE: {
    value: 3,
    type: "Online",
  },
  OFFSITE: {
    value: 4,
    type: "Offsite",
  },
  OTHER: {
    value: 5,
    type: "Other",
  },
};

export const ADD_SALE_ORDER_TYPE = [
  {
    value: 1,
    type: "Walk In",
    name: "WALK_IN",
  },
  {
    value: 2,
    type: "Phone",
    name: "PHONE",
  },
  {
    value: 3,
    type: "Online",
    name: "ONLINE",
  },
  {
    value: 4,
    type: "Offsite",
    name: "OFFSITE",
  },
  {
    value: 5,
    type: "Other",
  },
];

export const MESSAGE_TYPE_ESP = [
  {
    value: "email",
    label: "Email",
  },
  {
    value: "sms",
    label: "SMS",
  },
  {
    value: "push_notification",
    label: "Push Notification",
  },
];

export const Message_Recipient_TYPE = [
  {
    value: "all",
    label: "All",
  },

  {
    value: "selected_recipients",
    label: "Selected Recipients",
  },
];
export const MODULE_NAME_NOTIFICATIONS = {
  Stock: "/inventory/stock",
  StockAlert: "/inventory/stock-alerts",
  "Purchase Order": "/inventory/purchase/orders",
  PurchaseReceive: "/inventory/purchase/receives",
  StockTransfer: "/inventory/transfer/stocks",
  SaleOrder: "/sale/history",
  VendorProposal: "/inventory/vendor-portal",
  VendorOffer: "/inventory/vendor-portal",
  VendorProductProposal: "/inventory/vendor-portal",
  VendorMessageThread: "/inventory/vendor-portal?tab=messages",
};
export const PHONE_REG_EXP = /^\([0-9]{3}\)-[0-9]{3}-[0-9]{4}$/;
export const BUSINESS_NO_REG_EXP = /^[0-9]{2}-[0-9]{7}$/;
export const ZIP_CODE_REG_EXP = /^\d{5}(?:[-\s]\d{4})?$/;
export const STR_REG_EXP = /^[A-z]+$/;
export const INT_REG_EXP = /^[0-9]+$/;
export const TWO_DECIMAL_PLACES_INPUT = /^[0-9]+(?:\.[0-9]{1,2})?$/;
export const FLOAT_REG_EXP = /^[0-9]*(\.[0-9]{0,2})?$/;
export const STR_WITH_SC_REG_EXP = /^[A-z 0-9.&,-]+$/;
export const STR_WITH_CAT_REG_EXP = /[a-zA-Z0-9]/;
export const YOUTUBE_URL_REG_EXP = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
export const FACEBOOK_URL_REG_EXP =
  /(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?/;
export const TWITTER_URL_REG_EXP = /http(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/;
export const INSTAGRAM_URL_REG_EXP = /(https?:\/\/(?:www\.)?instagram\.com\/p\/([^/?#&]+)).*/;
export const EMAIL_REG_EXP = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
export const PASSWORD_REG_EXP =
  /^(?!\s)(?!.*\s$)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]).{8,}$/;
export const PURCHASE_RECEIPT_NO_REG_EXP = /^[1-9a-zA-Z0-9-]+$/;
export const SUPPLIER_WEBSITE_URL_REG_EXP =
  /^(?:https?:\/\/)?(?:(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+(?:[A-Z]{2,6}\.?|[A-Z0-9-]{2,}\.?)|localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::\d+)?(?:\/?|[\/?]\S+)$/i;

export const validateEmail = (email) => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailPattern.test(email);
};

export const STORAGE_TYPE = {
  WAREHOUSE: {
    value: 0,
    type: "Warehouse",
  },
  STOREFRONT: {
    value: 1,
    type: "Storefront",
  },
};
export const PICKUP_CHECKLIST_INVOICE_OPTIONS = {
  withoutImages: {
    value: 0,
    label: "Without Images",
  },
  withImages: {
    value: 1,
    label: "With Images",
  },
  showSKU: {
    value: 2,
    label: "Show SKU",
  },
  showUPC: {
    value: 3,
    label: "Without Images",
  },
  showSalePrice: {
    value: 4,
    label: "With Sale Price",
  },
  hideSalePrice: {
    value: 5,
    label: "Without Sale Price",
  },
};

export const ORDER_STATUS = {
  PENDING: {
    value: 10,
    type2: "Pending",
    type: <FormattedMessage id="Pending" defaultMessage="Pending" />,
    color: "#4d783f",
    slug: "pending",
  },
  PICKER_ASSIGNED: {
    value: 15,
    type2: "Picker Assigned",
    type: <FormattedMessage id="Picker Assigned" defaultMessage="Picker Assigned" />,
    color: "#4d783f",
    slug: "picker_assigned",
  },
  PARTIALLY_EXECUTED: {
    value: 35,
    type2: "Partially Executed",
    type: <FormattedMessage id="PARTIALLY_EXECUTED" defaultMessage="Partially Executed" />,
    color: "#95a5a6",
    slug: "partially_executed",
  },
  PICKING_IN_PROGRESS: {
    value: 21,
    type2: "Picking in progress",
    type: <FormattedMessage id="Picked in progress" defaultMessage="Picked in progress" />,
    color: "#117a8b",
    slug: "picking_in_progress",
  },
  PICKING_PARKED: {
    value: 22,
    type2: "Picking Paused",
    type: <FormattedMessage id="Picking Parked" defaultMessage="Picking Parked" />,
    color: "#f368e0",
    slug: "picking_parked",
  },
  PICKED: {
    value: 23,
    type2: "Picking Completed",
    type: <FormattedMessage id="Picked" defaultMessage="Picked" />,
    color: "#28a745",
    slug: "picked",
  },
  PACKING_IN_PROGRESS: {
    value: 26,
    type2: "Packing in progress",
    type: <FormattedMessage id="Packing in progress" defaultMessage="Packing in progress" />,
    color: "#c0592b",
    slug: "packing_in_progress",
  },
  PACKED: {
    value: 30,
    type2: "Packed",
    type: <FormattedMessage id="Packed" defaultMessage="Packed" />,
    color: "#c0592b",
    slug: "packed",
  },
  EXECUTED: {
    value: 40,
    type2: "Executed",
    type: <FormattedMessage id="Executed" defaultMessage="Executed" />,
    color: "#95a5a6",
    slug: "executed",
  },
  COMPLETED: {
    value: 50,
    type2: "Completed",
    type: <FormattedMessage id="Completed" defaultMessage="Completed" />,
    color: "#c0392b",
    slug: "completed",
  },
  RETURNED: {
    value: 60,
    type2: "Returned",
    dashboardType: "Returns",
    type: <FormattedMessage id="Returned" defaultMessage="Returned" />,
    color: "#95a5a6",
    slug: "returned",
  },
  PARTIALLY_RETURNED: {
    value: 55,
    type2: "Partially Returned",
    dashboardType: "Partially Returns",
    type: <FormattedMessage id="Partially Returned" defaultMessage="Partially Returned" />,
    color: "#95a5a6",
    slug: "returned",
  },
  PARKED: {
    value: 70,
    type2: "Parked",
    type: <FormattedMessage id="Parked" defaultMessage="Parked" />,
    color: "#f1c40f",
    slug: "parked",
  },
  DISCARDED: {
    value: 80,
    type2: "Discarded",
    type: <FormattedMessage id="Discarded" defaultMessage="Discarded" />,
    color: "#2980b9",
    slug: "discarded",
  },
  VOID: {
    value: 90,
    type2: "Void",
    type: <FormattedMessage id="Void" defaultMessage="Void" />,
    color: "#7C7C7C",
    slug: "void",
  },
};

export const NEW_FULFILLMENT_STATUS = {
  PENDING: {
    value: 10,
    type2: "Pending",
    type: <FormattedMessage id="Pending" defaultMessage="Pending" />,
    color: "#4d783f",
    slug: "pending",
  },
  PICKER_ASSIGNED: {
    value: 15,
    type2: "Picker Assigned",
    type: <FormattedMessage id="Picker Assigned" defaultMessage="Picker Assigned" />,
    color: "#4d783f",
    slug: "picker_assigned",
  },
  PARTIALLY_EXECUTED: {
    value: 35,
    type2: "Partially Executed",
    type: <FormattedMessage id="PARTIALLY_EXECUTED" defaultMessage="Partially Executed" />,
    color: "#95a5a6",
    slug: "partially_executed",
  },
  PICKING_IN_PROGRESS: {
    value: 21,
    type2: "Picking in progress",
    type: <FormattedMessage id="Picked in progress" defaultMessage="Picked in progress" />,
    color: "#117a8b",
    slug: "picking_in_progress",
  },
  PICKING_PARKED: {
    value: 22,
    type2: "Picking Paused",
    type: <FormattedMessage id="Picking Parked" defaultMessage="Picking Parked" />,
    color: "#f368e0",
    slug: "picking_parked",
  },
  PICKED: {
    value: 23,
    type2: "Picking Completed",
    type: <FormattedMessage id="Picked" defaultMessage="Picked" />,
    color: "#28a745",
    slug: "picked",
  },
  PACKING_IN_PROGRESS: {
    value: 26,
    type2: "Packing in progress",
    type: <FormattedMessage id="Packing in progress" defaultMessage="Packing in progress" />,
    color: "#c0592b",
    slug: "packing_in_progress",
  },
  PACKED: {
    value: 30,
    type2: "Packed",
    type: <FormattedMessage id="Packed" defaultMessage="Packed" />,
    color: "#c0592b",
    slug: "packed",
  },
};

// I write this util function to make further decision smooth, if you have any other easy suggesiton do change it. in future if backend dev upgrade with additional status or update existing status value just add it in this ternary values
export const Status = (data) =>
  data === 10
    ? "Pending"
    : data === 15
      ? "Picker Assigned"
      : data === 35
        ? "Partially Executed"
        : data === 21
          ? "Picking In Progress"
          : data === 22
            ? "Picking Paused"
            : data === 23
              ? "Picking Completed"
              : data === 26
                ? "Packing In Progress"
                : data === 30
                  ? "Packed"
                  : data === 40
                    ? "Executed"
                    : data === 50
                      ? "Completed"
                      : data === 60
                        ? "Returned"
                        : data === 70
                          ? "Parked"
                          : data === 80
                            ? "Discarded"
                            : data === 90
                              ? "Void"
                              : data === 55
                                ? "Partially Returned"
                                : "";

export const classes = {
  [ORDER_STATUS.PARKED.value]: "#f1c40f",
  [ORDER_STATUS.PICKING_IN_PROGRESS.value]: "#E0EDFF",
  [ORDER_STATUS.PICKER_ASSIGNED.value]: "#E0EDFF",
  [ORDER_STATUS.PACKING_IN_PROGRESS.value]: "#E0EDFF",
  [ORDER_STATUS.PICKING_PARKED.value]: "#FFF8DD",
  [ORDER_STATUS.PENDING.value]: "#E2D04A",
  [ORDER_STATUS.PICKED.value]: "#E0EDFF",
  [ORDER_STATUS.EXECUTED.value]: "#95a5a6",
  [ORDER_STATUS.DISCARDED.value]: "#2980b9",
  [ORDER_STATUS.COMPLETED.value]: "#28a745",
  [ORDER_STATUS.PACKED.value]: "#E0EDFF",
  [ORDER_STATUS.PARTIALLY_EXECUTED.value]: "#E7FFDD",
  [ORDER_STATUS.PARTIALLY_RETURNED.value]: "#c0598b",
};

export const SALE_ORDER_RETURN_STATUS = {
  RETURNED: {
    value: 50,
    type2: "Returned",
    dashboardType: "Returns",
    type: <FormattedMessage id="Returned" defaultMessage="Returned" />,
    color: "#95a5a6",
    slug: "returned",
  },
};

export const ATTRIBUTE_TYPE = {
  INPUT_TEXT: {
    value: "text",
    name: "Text",
  },
  INPUT_EMAIL: {
    value: "email",
    name: "Email",
  },
  INPUT_PASSWORD: {
    value: "password",
    name: "Password",
  },
  INPUT_NUMBER: {
    value: "number",
    name: "Number",
  },
  INPUT_DATE: {
    value: "date",
    name: "Date",
  },
  INPUT_URL: {
    value: "url",
    name: "URL",
  },
  // INPUT_COLOR: {
  //   value: "color",
  //   name: "Color",
  // },
  // INPUT_FILE: {
  //   value: "file",
  //   name: "File",
  // },
  TEXT_AREA: {
    value: "textarea",
    name: "Textarea",
  },
  INPUT_RADIO: {
    value: "radio",
    name: "Radio",
  },
  INPUT_CHECK_BOX: {
    value: "checkbox",
    name: "Checkbox",
  },
  SELECT: {
    value: "select",
    name: "Select",
  },
};

export const SALE_ATTRIBUTE_TYPE = {
  INPUT_TEXT: {
    value: "text",
    name: "Text",
  },
  INPUT_EMAIL: {
    value: "email",
    name: "Email",
  },
  // INPUT_PASSWORD: {
  //   value: "password",
  //   name: "Password",
  // },
  INPUT_NUMBER: {
    value: "number",
    name: "Number",
  },
  // INPUT_PHONE_NUMBER: {
  //   value: "phone_number",
  //   name: "Phone Number",
  // },
  INPUT_DATE: {
    value: "date",
    name: "Date",
  },
  INPUT_URL: {
    value: "url",
    name: "URL",
  },
  // INPUT_COLOR: {
  //   value: "color",
  //   name: "Color",
  // },
  // INPUT_FILE: {
  //   value: "file",
  //   name: "File",
  // },
  TEXT_AREA: {
    value: "textarea",
    name: "Textarea",
  },
  // INPUT_RADIO: {
  //   value: "radio",
  //   name: "Radio",
  // },
  // INPUT_CHECK_BOX: {
  //   value: "checkbox",
  //   name: "Checkbox",
  // },
  SELECT: {
    value: "select",
    name: "Select",
  },
};

export const PURCHASE_ORDER_REPORT_STATUS = {
  RECEIVED: {
    value: 1,
    type: "Received",
  },
  PENDING: {
    value: 2,
    type: "Pending",
  },
};
export function maskString(inputString, replaceWith = undefined) {
  const visibleChars = 4; // Number of characters to keep visible at the end
  const maskedLength = Math.max(inputString.length - visibleChars, 0);
  const maskedPart = (replaceWith || "*").repeat(maskedLength) + inputString.slice(-visibleChars);
  return maskedPart;
}
export const Default_status = [
  ORDER_STATUS.PENDING.value,
  ORDER_STATUS.PICKER_ASSIGNED.value,
  ORDER_STATUS.PICKED.value,
  ORDER_STATUS.PICKING_IN_PROGRESS.value,
  ORDER_STATUS.PICKING_PARKED.value,
  ORDER_STATUS.PACKED.value,
  ORDER_STATUS.PACKING_IN_PROGRESS.value,
  ORDER_STATUS.PARTIALLY_EXECUTED.value,
];

export const FULFILLMENT_STATUS = {
  PENDING: {
    value: 10,
    type: "Pending",
    color: "#f1c40f",
  },
  PICKER_ASSIGNED: {
    value: 15,
    type2: "Picker Assigned",
    color: "#4d783f",
  },
  PICKING_IN_PROGRESS: {
    value: 21,
    type: "Picking in Progress",
    color: "#117a9b",
  },
  PICKING_PARKED: {
    value: 22,
    type: "Picking Parked",
    color: "#117a7b",
  },
  PICKED: {
    value: 23,
    type: "Picking Completed",
    color: "#117a8b",
  },
  PACKED: {
    value: 30,
    type: "Packed",
    color: "#f368e0",
  },
};

export const STOCK_STATUS = {
  IN_HAND: {
    value: 6,
    type: "Available",
    color: "",
  },
  ON_HOLD: {
    value: 3,
    type: "On Hold",
    color: "label-light-warning",
  },
  DAMAGED: {
    value: 8,
    type: "Damaged",
    color: "label-light-danger",
  },
  REJECTED: {
    value: 4,
    type: "Rejected",
    color: "label-light-danger",
  },
  UNDER_INSPECTION: {
    value: 2,
    type: "Under inspection",
    color: "label-light-success",
  },
  RECEIVED: {
    value: 1,
    type: "Received",
    color: "label-light-primary",
  },
  OPEN: {
    value: 5,
    type: "Open",
    color: "label-light-info",
  },
  DELIVERED: {
    value: 7,
    type: "Delivered",
    color: "label-light-success",
  },
  BACK_ORDER: {
    value: 9,
    type: "Back Order",
    color: "label-light-primary",
  },
  HOLD_FREE_SHIPPING: {
    value: 10,
    type: "Delivered Without Stock",
    color: "label-light-primary",
  },
  COMING_SOON: {
    value: 11,
    type: "Coming Soon",
    color: "label-light-primary",
  },
};
export const STOCK_STATUS_OBJ = {
  6: STOCK_STATUS.IN_HAND,
  3: STOCK_STATUS.ON_HOLD,
  8: STOCK_STATUS.DAMAGED,
  1: STOCK_STATUS.RECEIVED,
  2: STOCK_STATUS.UNDER_INSPECTION,
  4: STOCK_STATUS.REJECTED,
  5: STOCK_STATUS.OPEN,
  7: STOCK_STATUS.DELIVERED,
  10: STOCK_STATUS.HOLD_FREE_SHIPPING,
  9: STOCK_STATUS.BACK_ORDER,
  11: STOCK_STATUS.COMING_SOON,
};
export const SALE_RETURN_STATUS = {
  IN_HAND: {
    value: 6,
    type: "Available",
    color: "",
  },
  DAMAGED: {
    value: 8,
    type: "Damaged",
    color: "label-light-danger",
  },
  MISSING: {
    value: 12,
    type: "Missing",
    color: "label-light-info",
  },
  EXPIRED: {
    value: 13,
    type: "Expired",
    color: "label-light-warning",
  },
};
export const STOCK_RETURNABLE_STATUS = {
  RECEIVED: {
    value: 1,
    type: "Received",
  },
  UNDER_INSPECTION: {
    value: 2,
    type: "Under Inspection",
  },
  ON_HOLD: {
    value: 3,
    type: "On Hold",
  },
  IN_HAND: {
    value: 6,
    type: "Available",
  },
};
export const TOOLTIP_BG = {
  color: "#F0F0F0",
  textColor: "black",
};
export const RETURN_CART_PRODUCT_TYPE = {
  OLD: 1,
  NEW: 2,
  RETURNED: 3,
};

export const DISCOUNT_TYPE = {
  PERCENTAGE: 1,
  FIXED: 2,
};

export const TAX_TYPE = {
  PERCENTAGE: 1,
  FIXED: 2,
};
export const SALE_DISCOUNT_TYPE = {
  PERCENTAGE: {
    value: 1,
    type: "%",
  },
  FIXED: {
    value: 2,
    type: "$",
  },
};

export const SALE_INVOICE_TYPE = {
  SALE: {
    value: 1,
    type: "Sale Invoice",
  },
  RETURN: {
    value: 2,
    type: "Return Invoice",
  },
  COMBINE: {
    value: 3,
    type: "",
  },
};

export const PERFECT_SCROLLBAR_OPTIONS = {
  wheelSpeed: 2,
  wheelPropagation: false,
  suppressScrollY: false,
};

export const CATEGORY_ATTRIBUTE_STATUS = {
  LINKED: {
    value: 1,
    type: "Linked",
  },
  NOT_LINKED: {
    value: 0,
    type: "Not Linked",
  },
};

export const USA_STATES = {
  ALABAMA: {
    value: "AL",
    text: "AL",
  },
  ALASKA: {
    value: "AK",
    text: "AK",
  },
  ARIZONA: {
    value: "AZ",
    text: "AZ",
  },
  ARKANSAS: {
    value: "AR",
    text: "AR",
  },
  CALIFORNIA: {
    value: "CA",
    text: "CA",
  },
  COLORADO: {
    value: "CO",
    text: "CO",
  },
  CONNECTICUT: {
    value: "CT",
    text: "CT",
  },
  DELAWARE: {
    value: "DE",
    text: "DE",
  },
  DISTRICT_OF_COLUMBIA: {
    value: "DC",
    text: "DC",
  },
  FLORIDA: {
    value: "FL",
    text: "FL",
  },
  GEORGIA: {
    value: "GA",
    text: "GA",
  },
  HAWAII: {
    value: "HI",
    text: "HI",
  },
  IDAHO: {
    value: "ID",
    text: "ID",
  },
  ILLINOIS: {
    value: "IL",
    text: "IL",
  },
  INDIANA: {
    value: "IN",
    text: "IN",
  },
  IOWA: {
    value: "IA",
    text: "IA",
  },
  KANSAS: {
    value: "KS",
    text: "KS",
  },
  KENTUCKY: {
    value: "KY",
    text: "KY",
  },
  LOUISIANA: {
    value: "LA",
    text: "LA",
  },
  MAINE: {
    value: "ME",
    text: "ME",
  },
  MARYLAND: {
    value: "MD",
    text: "MD",
  },
  MASSACHUSETTS: {
    value: "MA",
    text: "MA",
  },
  MICHIGAN: {
    value: "MI",
    text: "MI",
  },
  MINNESOTA: {
    value: "MN",
    text: "MN",
  },
  MISSISSIPPI: {
    value: "MS",
    text: "MS",
  },
  MISSOURI: {
    value: "MO",
    text: "MO",
  },
  MONTANA: {
    value: "MT",
    text: "MT",
  },
  NEBRASKA: {
    value: "NE",
    text: "NE",
  },
  NEVADA: {
    value: "NV",
    text: "NV",
  },
  NEW_HAMPSHIRE: {
    value: "NH",
    text: "NH",
  },
  NEW_JERSEY: {
    value: "NJ",
    text: "NJ",
  },
  NEW_MEXICO: {
    value: "NM",
    text: "NM",
  },
  NEW_YORK: {
    value: "NY",
    text: "NY",
  },
  NORTH_CAROLINA: {
    value: "NC",
    text: "NC",
  },
  NORTH_DAKOTA: {
    value: "ND",
    text: "ND",
  },
  OHIO: {
    value: "OH",
    text: "OH",
  },
  OKLAHOMA: {
    value: "OK",
    text: "OK",
  },
  OREGON: {
    value: "OR",
    text: "OR",
  },
  PENNSYLVANIA: {
    value: "PA",
    text: "PA",
  },
  RHODE_ISLAND: {
    value: "RI",
    text: "RI",
  },
  SOUTH_CAROLINA: {
    value: "SC",
    text: "SC",
  },
  SOUTH_DAKOTA: {
    value: "SD",
    text: "SD",
  },
  TENNESSEE: {
    value: "TN",
    text: "TN",
  },
  TEXAS: {
    value: "TX",
    text: "TX",
  },
  UTAH: {
    value: "UT",
    text: "UT",
  },
  VERMONT: {
    value: "VT",
    text: "VT",
  },
  VIRGINIA: {
    value: "VA",
    text: "VA",
  },
  WASHINGTON: {
    value: "WA",
    text: "WA",
  },
  WEST_VIRGINIA: {
    value: "WV",
    text: "WV",
  },
  WISCONSIN: {
    value: "WI",
    text: "WI",
  },
  WYOMING: {
    value: "WY",
    text: "WY",
  },
};

export const USER_TYPE = {
  OWNER: {
    type: 1,
    value: "Owner",
  },
  ADMIN: {
    type: 2,
    value: "Admin",
  },
  CASHIER: {
    type: 3,
    value: "Cashier",
  },
  SALE_AGENT: {
    type: 4,
    value: "Sales Rep",
  },
  WH_USER: {
    type: 5,
    value: "Warehouse User",
  },
  WH_PICKER: {
    type: 6,
    value: "Warehouse Picker",
  },
  STORE_MANAGER: {
    type: 7,
    value: "Store Manager",
  },
  ACCOUNT_USER: {
    type: 8,
    value: "Account User",
  },
};
export const USER_STATUS = {
  ACTIVE: {
    type: 1,
    value: "Active",
    color: "#28a745",
  },
  INACTIVE: {
    type: 0,
    value: "In Active",
    color: "#c0392b",
  },
};

export const BACKGROUND_TASK_KEYS = {
  BRAND_EXPORT: {
    title: "Brand Export",
    key: "BEid",
  },
  CATEGORY_EXPORT: {
    title: "Category Export",
    key: "categoryExportToken",
  },
  CATEGORY_IMPORT: {
    title: "Category Import",
    key: "categoryImportToken",
  },
  PRODUCT_IMPORT: {
    title: "Product Import",
    key: "productImportToken",
  },
  STOCK_IMPORT: {
    title: "Stock Import",
    key: "stockImportToken",
  },
  SUPPLIER_IMPORT: {
    title: "Supplier Import",
    key: "supplierImportToken",
  },
  CUSTOMER_IMPORT: {
    title: "Customer Import",
    key: "customerImportToken",
  },
  MSA_PARSER: {
    title: "MSA Parser",
    key: "msaParserTaskId",
  },
  MSA_GENERATOR: {
    title: "MSA Generator",
    key: "MSA_ID",
  },
  AUTO_APPLY_CREDIT: {
    title: "Auto Apply Store Credit",
    key: "autoApplyCreditTaskId",
  },
  AUTO_APPLY_CREDIT_SUPPLIER: {
    title: "Auto Apply Supplier Credit",
    key: "autoApplyCreditSupplierTaskId",
  },
};

export const PRODUCT_IMPORT_COLUMNS = [
  { header: "id", key: "id", width: 6, font: { bold: true } },
  { header: "name", key: "name", width: 14, font: { bold: true } },
  { header: "description", key: "description", width: 32, font: { bold: true } },
  { header: "cost", key: "cost", width: 10, font: { bold: true } },
  { header: "margin", key: "margin", width: 10, font: { bold: true } },
  { header: "margin_type", key: "margin_type", width: 13, font: { bold: true } },
  { header: "sku", key: "sku", width: 28, font: { bold: true } },
  // { header: "min_qty", key: "min_qty", width: 10, font: { bold: true } },
  // { header: "max_qty", key: "max_qty", width: 10, font: { bold: true } },
  { header: "upc", key: "upc", width: 20, font: { bold: true } },
  { header: "mlc", key: "mlc", width: 20, font: { bold: true } },
  { header: "bin", key: "bin", width: 20, font: { bold: true } },
  { header: "gtn", key: "gtn", width: 20, font: { bold: true } },
  { header: "is_online", key: "is_online", width: 10, font: { bold: true } },
  { header: "status", key: "status", width: 14, font: { bold: true } },
  { header: "weight", key: "weight", width: 10, font: { bold: true } },
  { header: "weight_unit", key: "weight_unit", width: 12, font: { bold: true } },
  { header: "brand_id", key: "brand_id", width: 10, font: { bold: true } },
  { header: "brand_name", key: "brand_name", width: 14, font: { bold: true } },
  { header: "category_ids", key: "category_ids", width: 20, font: { bold: true } },
  { header: "category_names", key: "category_names", width: 40, font: { bold: true } },
  { header: "tag_values", key: "tag_values", width: 20, font: { bold: true } },
  { header: "supplier_ids", key: "supplier_ids", width: 20, font: { bold: true } },
];

export const PRODUCT_SIMPLE_DATA = [
  {
    id: 10,
    name: "Nice item",
    description: "Tobacco",
    cost: 23,
    margin: 34,
    margin_type: "FIXED",
    sku: "<auto>",
    min_qty: 50,
    max_qty: 100,
    upc: "458296475748",
    is_online: "YES",
    status: "ACTIVE",
    weight: 10,
    weight_unit: "OZ",
    brand_id: 5,
    category_ids: "1, 4, 6",
    tag_values: "Smoke,Tobacco",
    supplier_ids: "2, 4",
  },
  {
    name: "Marlobo",
    description: "Cigaratte",
    cost: 24,
    margin: 0.1,
    margin_type: "PERCENTAGE",
    sku: "325-MALOB-1234",
    min_qty: 10,
    max_qty: 60,
    upc: "758694259751",
    is_online: "NO",
    status: "INACTIVE",
    brand_id: 1,
    category_ids: "2, 4, 5",
    supplier_ids: "2, 4",
  },
  {
    name: "warrior",
    description: "Handmade ",
    cost: 43,
    margin: 0.05,
    margin_type: "PERCENTAGE",
    sku: "047-WAROR-5816",
    min_qty: 40,
    max_qty: 200,
    upc: "159092043754",
    mlc: "758963",
    is_online: "YES",
    status: "DISCONTINUED",
    weight: "2",
    weight_unit: "OZ",
    brand_id: 2,
    category_names: "Clothes->Male,Female->Girls; Clothes->Kids,Male->Boys",
    tag_values: "Handmade, Clothes",
    supplier_ids: "5,6",
  },
  {
    id: 2,
    name: "brown roll",
    description: "Helps roll the tobacco",
    cost: 101,
    margin: 0.05,
    margin_type: "PERCENTAGE",
    sku: "359-ROLBRO-6584",
    min_qty: 100,
    max_qty: 300,
    upc: "758963244312",
    is_online: "YES",
    status: "ACTIVE",
    weight: "44",
    weight_unit: "LB",
    brand_id: 4,
    category_names: "Foods->Bakery->Sweets",
    tag_values: "Sweets",
    supplier_ids: "23",
  },
  {
    name: "pines",
    description: "Air fresherner",
    cost: 23,
    margin: 0.2,
    margin_type: "PERCENTAGE",
    sku: "658-AIFRNR-1122",
    min_qty: 40,
    max_qty: 100,
    upc: "609361028315",
    mlc: "1231231",
    bin: "60936",
    is_online: "NO",
    status: "INACTIVE",
    brand_name: "GUCCI",
    category_names: "Foods->Bakery->Sweets",
    supplier_ids: "4",
  },
  {
    id: 1,
    name: "Power pops",
    description: "electric cigraratte",
    cost: 45,
    margin: 100,
    margin_type: "FIXED",
    sku: "485-POWRP-4571",
    min_qty: 30,
    max_qty: 300,
    upc: "u639600837285",
    is_online: "YES",
    status: "DISCONTINUED",
    weight: 24,
    weight_unit: "LB",
    brand_name: "Nike",
    category_ids: "2,5",
    supplier_ids: "22",
  },
  {
    name: "Pyp4",
    description: "Pipes for vapor",
    cost: 50,
    margin: 200,
    margin_type: "FIXED",
    sku: "<auto>",
    min_qty: 20,
    max_qty: 500,
    mlc: "2323",
    is_online: "NO",
    status: "ACTIVE",
    brand_name: "BURBERRY",
    category_ids: "5",
    supplier_ids: "1,3,5,6",
  },
  {
    id: 23,
    name: "cool5",
    description: "Energy drink",
    cost: 20,
    margin: 50,
    margin_type: "FIXED",
    sku: "748-5COOL-1345",
    min_qty: 5,
    max_qty: 90,
    upc: "u700080455224",
    gtn: "609315",
    is_online: "NO",
    status: "ACTIVE",
    brand_id: 10,
    category_ids: "7,10",
    supplier_ids: "6",
  },
  {
    name: "relax",
    description: "CBD oil",
    cost: 30,
    margin: 0.1,
    margin_type: "PERCENTAGE",
    sku: "204-RLAXC-4186",
    min_qty: 5,
    max_qty: 100,
    upc: "730320264193",
    is_online: "YES",
    status: "INACTIVE",
    weight: 53,
    weight_unit: "OZ",
    brand_id: 4,
    category_ids: "2,6",
    supplier_ids: "12,221,4",
  },
  {
    name: "Pure H20",
    description: "Pure drinking water",
    cost: 50,
    margin: 0.05,
    margin_type: "PERCENTAGE",
    sku: "<auto>",
    min_qty: 10,
    max_qty: 40,
    is_online: "YES",
    status: "ACTIVE",
    weight: 13,
    weight_unit: "OZ",
    brand_name: "Nike",
    category_ids: "7",
    supplier_ids: "225, 54",
  },
  {
    name: "juice fresh",
    description: "Like freshly pressed juice",
    cost: 20,
    margin: 50,
    margin_type: "FIXED",
    sku: "<auto>",
    min_qty: 30,
    max_qty: 200,
    upc: "790799882132",
    bin: "790782",
    is_online: "NO",
    status: "DISCONTINUED",
    weight: 25,
    weight_unit: "LB",
    brand_name: "GUCCI",
    category_ids: "4",
    supplier_ids: "2, 6",
  },
];
export const tooltipData = {
  icon: "/media/svg/icons/Shopping/information2.svg",
};
export const EXPORT_PRODUCTS_OPTIONS = {
  DETAIL: {
    value: 1,
    name: "Detail",
  },
  PRICES: {
    value: 2,
    name: "Prices",
  },
  VARIANTS: {
    value: 3,
    name: "Variants",
  },
  BULK_TEMPLATE: {
    value: 4,
    name: "BulkTemplatw",
  },
  NEW_PRODUCTS: {
    value: 5,
    name: "newProducts",
  },
};

export const AGREE_TYPE = {
  Yes: {
    name: "Yes",
    value: "Y",
  },
  No: {
    name: "No",
    value: "N",
  },
};

export const ECOM_ALLOW_TYPE = {
  Restrict: {
    name: "Restrict",
    value: 1,
  },
  Allow: {
    name: "Allow",
    value: 2,
  },
};

export const OUT_OF_STATE_CUSTOMER = {
  Yes: {
    name: "Yes",
    value: 1,
  },
  No: {
    name: "No",
    value: 0,
  },
};

export const CUSTOMER_SEARCH_CATEGORY = {
  searchByName: "Search by Customer Name",
  searchById: "Search by Customer Id",
  searchByEmail: "Search by Customer Email",
};

export const AGING_TYPE = {
  DueImmediately: {
    defaultSelect: true,
    name: "Due Immediately",
    value: 0,
  },
  Days7: {
    name: "7 Days",
    value: 7,
  },
  Days15: {
    name: "15 Days",
    value: 15,
  },
  Days30: {
    name: "30 Days",
    value: 30,
  },
  Custom: {
    name: "Custom",
    value: -1,
  },
};

export const CLASS_OF_TRADE = {
  Retailer: {
    name: "Retailer",
    value: "Retailer",
    value2: 1
  },
  Distributor: {
    name: "Distributor",
    value: "Distributor",
    value2: 2
  },
  Wholesaler: {
    name: "Wholesaler",
    value: "Wholesaler",
    value2: 3
  },
  ShowWholesaler: {
    name: "Show Wholesaler",
    value: "Show Wholesaler",
    value2: 4
  },
  SubDistro: {
    name: "Sub-Distro",
    value: "Sub-Distro",
    value2: 5
  },
  SmokeShop: {
    name: "Smoke Shop",
    value: "Smoke Shop",
    value2: 6
  },
  ShowSmoke: {
    name: "Show Smoke Shop",
    value: "Show Smoke Shop",
    value2: 7
  },
  Other: {
    name: "Other",
    value: "other",
    value2: 8
  },
};

export const TierOptions = [
  { label: "Tier 1", key: 1, value: 1 },
  { label: "Tier 2", key: 2, value: 2 },
  { label: "Tier 3", key: 3, value: 3 },
  { label: "Tier 4", key: 4, value: 4 },
  { label: "Tier 5", key: 5, value: 5 },
  { label: "None", key: 5, value: null },
];

export const CUSTOMER_TAX_PREFERENCE = {
  TAXABLE: {
    name: "Taxable",
    value: "N",
  },
  TAX_EXEMPT: {
    name: "Tax Exempt",
    value: "Y",
  },
};

export const SUPPLIER_TAX_PREFERENCE = {
  TAXABLE: {
    name: "Taxable",
    value: "N",
  },
  TAX_EXEMPT: {
    name: "Tax Exempt",
    value: "Y",
  },
};

export const PURCHASE_PAYABLE_BY_FOR_TAX = {
  SUPPLIER: 1,
  TENANT_NAME: 2,
};

export const TAX_PAYMENT_METHOD = {
  PREPAID_TAXES: {
    name: "Prepaid Taxes",
    value: 1,
  },
  DEFERRED_TAXES: {
    name: "Deferred Taxes",
    value: 2,
  },
};

export const CUSTOMER_TYPE = {
  WALK_IN: {
    name: "Walk In",
    value: 1,
  },
  ONLINE: {
    name: "Online",
    value: 2,
  },
  NONE: {
    name: "None",
    value: 3,
  },
};

export const INTEGRATION_STATUS = {
  IN_ACTIVE: {
    name: "Not Installed",
    to: ["Install"],
    value: 1,
  },
  ACTIVE: {
    name: "Installed",
    to: ["Uninstall"],
    value: 2,
  },
  //  PAUSED: {
  //    name: "Paused",
  //    to: ["Resume", "Uninstall"],
  //    value: 3
  //  }
  CONNECT: {
    name: "Connect",
    to: ["Connect Ship Station"],
    value: 3,
  },
  CONNECT_PENDING: {
    name: "Pending",
    to: ["Continue Setup"],
    value: 4,
  },
  CONNECT_ACTIVE: {
    name: "Active",
    to: ["Manage"],
    value: 5,
  },
  CONNECT_FAILED: {
    name: "Failed",
    to: ["Retry Setup"],
    value: 6,
  },
};

export const INTEGRATION_STATUS_OBJ = {
  1: INTEGRATION_STATUS.IN_ACTIVE,
  2: INTEGRATION_STATUS.ACTIVE,
  3: INTEGRATION_STATUS.CONNECT,
  4: INTEGRATION_STATUS.CONNECT_PENDING,
  5: INTEGRATION_STATUS.CONNECT_ACTIVE,
  6: INTEGRATION_STATUS.CONNECT_FAILED,
};

export const CUSTOMER_GROUP_STATUS = {
  ACTIVE: {
    name: "Active",
    value: true,
  },
  PAUSE: {
    name: "Pause",
    value: false,
  },
};

export const AGREE_TYPE_SALE = {
  Yes: {
    text: "Yes",
    value: "Y",
  },
  No: {
    text: "No",
    value: "N",
  },
};

export const MESSAGE_TYPE = {
  ERROR: "error",
  SUCCESS: "success",
  MODAL_SUCCESS: "modalSuccess",
  MODAL_ERROR: "modalError",
};

export const CLASS_OF_TRADE_SALE = {
  Retailer: {
    text: "Retailer",
    value: "Retailer",
  },
  Distributor: {
    text: "Distributor",
    value: "Distributor",
  },
  Other: {
    text: "Other",
    value: "other",
  },
};

export const VIDEO_TYPE = {
  VIDEO: { text: "Video", value: 4 },
  YOUTUBE_LINK: { text: "Youtube Link", value: 5 },
};

export const SOCKET_MAX_RETRIES = 3;
export const CURRENCYSYMBOL = {
  AFA: "؋",
  ALL: "Lek",
  DZD: "دج",
  AOA: "Kz",
  ARS: "$",
  AMD: "֏",
  AWG: "ƒ",
  AUD: "$",
  AZN: "m",
  BSD: "B$",
  BHD: ".د.ب",
  BDT: "৳",
  BBD: "Bds$",
  BYR: "Br",
  BEF: "fr",
  BZD: "$",
  BMD: "$",
  BTN: "Nu.",
  BTC: "฿",
  BOB: "Bs.",
  BAM: "KM",
  BWP: "P",
  BRL: "R$",
  GBP: "£",
  BND: "B$",
  BGN: "Лв.",
  BIF: "FBu",
  KHR: "KHR",
  CAD: "$",
  CVE: "$",
  KYD: "$",
  XOF: "CFA",
  XAF: "FCFA",
  XPF: "₣",
  CLP: "$",
  CNY: "¥",
  COP: "$",
  KMF: "CF",
  CDF: "FC",
  CRC: "₡",
  HRK: "kn",
  CUC: "$, CUC",
  CZK: "Kč",
  DKK: "Kr.",
  DJF: "Fdj",
  DOP: "$",
  XCD: "$",
  EGP: "ج.م",
  ERN: "Nfk",
  EEK: "kr",
  ETB: "Nkf",
  EUR: "€",
  FKP: "£",
  FJD: "FJ$",
  GMD: "D",
  GEL: "ლ",
  DEM: "DM",
  GHS: "GH₵",
  GIP: "£",
  GRD: "₯, Δρχ, Δρ",
  GTQ: "Q",
  GNF: "FG",
  GYD: "$",
  HTG: "G",
  HNL: "L",
  HKD: "$",
  HUF: "Ft",
  ISK: "kr",
  INR: "₹",
  IDR: "Rp",
  IRR: "﷼",
  IQD: "د.ع",
  ILS: "₪",
  ITL: "L,£",
  JMD: "J$",
  JPY: "¥",
  JOD: "ا.د",
  KZT: "лв",
  KES: "KSh",
  KWD: "ك.د",
  KGS: "лв",
  LAK: "₭",
  LVL: "Ls",
  LBP: "£",
  LSL: "L",
  LRD: "$",
  LYD: "د.ل",
  LTL: "Lt",
  MOP: "$",
  MKD: "ден",
  MGA: "Ar",
  MWK: "MK",
  MYR: "RM",
  MVR: "Rf",
  MRO: "MRU",
  MUR: "₨",
  MXN: "$",
  MDL: "L",
  MNT: "₮",
  MAD: "MAD",
  MZM: "MT",
  MMK: "K",
  NAD: "$",
  NPR: "₨",
  ANG: "ƒ",
  TWD: "$",
  NZD: "$",
  NIO: "C$",
  NGN: "₦",
  KPW: "₩",
  NOK: "kr",
  OMR: ".ع.ر",
  PKR: "₨",
  PAB: "B/.",
  PGK: "K",
  PYG: "₲",
  PEN: "S/.",
  PHP: "₱",
  PLN: "zł",
  QAR: "ق.ر",
  RON: "lei",
  RUB: "₽",
  RWF: "FRw",
  SVC: "₡",
  WST: "SAT",
  SAR: "﷼",
  RSD: "din",
  SCR: "SRe",
  SLL: "Le",
  SGD: "$",
  SKK: "Sk",
  SBD: "Si$",
  SOS: "Sh.so.",
  ZAR: "R",
  KRW: "₩",
  XDR: "SDR",
  LKR: "Rs",
  SHP: "£",
  SDG: ".س.ج",
  SRD: "$",
  SZL: "E",
  SEK: "kr",
  CHF: "CHf",
  SYP: "LS",
  STD: "Db",
  TJS: "SM",
  TZS: "TSh",
  THB: "฿",
  TOP: "$",
  TTD: "$",
  TND: "ت.د",
  TRY: "₺",
  TMT: "T",
  UGX: "USh",
  UAH: "₴",
  AED: "إ.د",
  UYU: "$",
  USD: "$",
  UZS: "лв",
  VUV: "VT",
  VEF: "Bs",
  VND: "₫",
  YER: "﷼",
  ZMK: "ZK",
};

export const COUNTRIES = {
  Afghanistan: { iso2: "af", phone_code: "93" },
  "Aland Islands": { iso2: "ax", phone_code: "+358-18" },
  Albania: { iso2: "al", phone_code: "355" },
  Algeria: { iso2: "dz", phone_code: "213" },
  "American Samoa": { iso2: "as", phone_code: "+1-684" },
  Andorra: { iso2: "ad", phone_code: "376" },
  Angola: { iso2: "ao", phone_code: "244" },
  Anguilla: { iso2: "ai", phone_code: "+1-264" },
  Antarctica: { iso2: "aq", phone_code: "672" },
  "Antigua And Barbuda": { iso2: "ag", phone_code: "+1-268" },
  Argentina: { iso2: "ar", phone_code: "54" },
  Armenia: { iso2: "am", phone_code: "374" },
  Aruba: { iso2: "aw", phone_code: "297" },
  Australia: { iso2: "au", phone_code: "61" },
  Austria: { iso2: "at", phone_code: "43" },
  Azerbaijan: { iso2: "az", phone_code: "994" },
  Bahrain: { iso2: "bh", phone_code: "973" },
  Bangladesh: { iso2: "bd", phone_code: "880" },
  Barbados: { iso2: "bb", phone_code: "+1-246" },
  Belarus: { iso2: "by", phone_code: "375" },
  Belgium: { iso2: "be", phone_code: "32" },
  Belize: { iso2: "bz", phone_code: "501" },
  Benin: { iso2: "bj", phone_code: "229" },
  Bermuda: { iso2: "bm", phone_code: "+1-441" },
  Bhutan: { iso2: "bt", phone_code: "975" },
  Bolivia: { iso2: "bo", phone_code: "591" },
  "Bonaire, Sint Eustatius and Saba": { iso2: "bq", phone_code: "599" },
  "Bosnia and Herzegovina": { iso2: "ba", phone_code: "387" },
  Botswana: { iso2: "bw", phone_code: "267" },
  "Bouvet Island": { iso2: "bv", phone_code: "0055" },
  Brazil: { iso2: "br", phone_code: "55" },
  "British Indian Ocean Territory": { iso2: "io", phone_code: "246" },
  Brunei: { iso2: "bn", phone_code: "673" },
  Bulgaria: { iso2: "bg", phone_code: "359" },
  "Burkina Faso": { iso2: "bf", phone_code: "226" },
  Burundi: { iso2: "bi", phone_code: "257" },
  Cambodia: { iso2: "kh", phone_code: "855" },
  Cameroon: { iso2: "cm", phone_code: "237" },
  Canada: { iso2: "ca", phone_code: "1" },
  "Cape Verde": { iso2: "cv", phone_code: "238" },
  "Cayman Islands": { iso2: "ky", phone_code: "+1-345" },
  "Central African Republic": { iso2: "cf", phone_code: "236" },
  Chad: { iso2: "td", phone_code: "235" },
  Chile: { iso2: "cl", phone_code: "56" },
  China: { iso2: "cn", phone_code: "86" },
  "Christmas Island": { iso2: "cx", phone_code: "61" },
  "Cocos (Keeling) Islands": { iso2: "cc", phone_code: "61" },
  Colombia: { iso2: "co", phone_code: "57" },
  Comoros: { iso2: "km", phone_code: "269" },
  Congo: { iso2: "cg", phone_code: "242" },
  "Cook Islands": { iso2: "ck", phone_code: "682" },
  "Costa Rica": { iso2: "cr", phone_code: "506" },
  "Cote D'Ivoire (Ivory Coast)": { iso2: "ci", phone_code: "225" },
  Croatia: { iso2: "hr", phone_code: "385" },
  Cuba: { iso2: "cu", phone_code: "53" },
  Curaçao: { iso2: "cw", phone_code: "599" },
  Cyprus: { iso2: "cy", phone_code: "357" },
  "Czech Republic": { iso2: "cz", phone_code: "420" },
  "Democratic Republic of the Congo": { iso2: "cd", phone_code: "243" },
  Denmark: { iso2: "dk", phone_code: "45" },
  Djibouti: { iso2: "dj", phone_code: "253" },
  Dominica: { iso2: "dm", phone_code: "+1-767" },
  "Dominican Republic": { iso2: "do", phone_code: "+1-809 and 1-829" },
  "East Timor": { iso2: "tl", phone_code: "670" },
  Ecuador: { iso2: "ec", phone_code: "593" },
  Egypt: { iso2: "eg", phone_code: "20" },
  "El Salvador": { iso2: "sv", phone_code: "503" },
  "Equatorial Guinea": { iso2: "gq", phone_code: "240" },
  Eritrea: { iso2: "er", phone_code: "291" },
  Estonia: { iso2: "ee", phone_code: "372" },
  Ethiopia: { iso2: "et", phone_code: "251" },
  "Falkland Islands": { iso2: "fk", phone_code: "500" },
  "Faroe Islands": { iso2: "fo", phone_code: "298" },
  "Fiji Islands": { iso2: "fj", phone_code: "679" },
  Finland: { iso2: "fi", phone_code: "358" },
  France: { iso2: "fr", phone_code: "33" },
  "French Guiana": { iso2: "gf", phone_code: "594" },
  "French Polynesia": { iso2: "pf", phone_code: "689" },
  "French Southern Territories": { iso2: "tf", phone_code: "262" },
  Gabon: { iso2: "ga", phone_code: "241" },
  "Gambia The": { iso2: "gm", phone_code: "220" },
  Georgia: { iso2: "ge", phone_code: "995" },
  Germany: { iso2: "de", phone_code: "49" },
  Ghana: { iso2: "gh", phone_code: "233" },
  Gibraltar: { iso2: "gi", phone_code: "350" },
  Greece: { iso2: "gr", phone_code: "30" },
  Greenland: { iso2: "gl", phone_code: "299" },
  Grenada: { iso2: "gd", phone_code: "+1-473" },
  Guadeloupe: { iso2: "gp", phone_code: "590" },
  Guam: { iso2: "gu", phone_code: "+1-671" },
  Guatemala: { iso2: "gt", phone_code: "502" },
  "Guernsey and Alderney": { iso2: "gg", phone_code: "+44-1481" },
  Guinea: { iso2: "gn", phone_code: "224" },
  "Guinea-Bissau": { iso2: "gw", phone_code: "245" },
  Guyana: { iso2: "gy", phone_code: "592" },
  Haiti: { iso2: "ht", phone_code: "509" },
  "Heard Island and McDonald Islands": { iso2: "hm", phone_code: "672" },
  Honduras: { iso2: "hn", phone_code: "504" },
  "Hong Kong S.A.R.": { iso2: "hk", phone_code: "852" },
  Hungary: { iso2: "hu", phone_code: "36" },
  Iceland: { iso2: "is", phone_code: "354" },
  India: { iso2: "in", phone_code: "91" },
  Indonesia: { iso2: "id", phone_code: "62" },
  Iran: { iso2: "ir", phone_code: "98" },
  Iraq: { iso2: "iq", phone_code: "964" },
  Ireland: { iso2: "ie", phone_code: "353" },
  Israel: { iso2: "il", phone_code: "972" },
  Italy: { iso2: "it", phone_code: "39" },
  Jamaica: { iso2: "jm", phone_code: "+1-876" },
  Japan: { iso2: "jp", phone_code: "81" },
  Jersey: { iso2: "je", phone_code: "+44-1534" },
  Jordan: { iso2: "jo", phone_code: "962" },
  Kazakhstan: { iso2: "kz", phone_code: "7" },
  Kenya: { iso2: "ke", phone_code: "254" },
  Kiribati: { iso2: "ki", phone_code: "686" },
  Kosovo: { iso2: "xk", phone_code: "383" },
  Kuwait: { iso2: "kw", phone_code: "965" },
  Kyrgyzstan: { iso2: "kg", phone_code: "996" },
  Laos: { iso2: "la", phone_code: "856" },
  Latvia: { iso2: "lv", phone_code: "371" },
  Lebanon: { iso2: "lb", phone_code: "961" },
  Lesotho: { iso2: "ls", phone_code: "266" },
  Liberia: { iso2: "lr", phone_code: "231" },
  Libya: { iso2: "ly", phone_code: "218" },
  Liechtenstein: { iso2: "li", phone_code: "423" },
  Lithuania: { iso2: "lt", phone_code: "370" },
  Luxembourg: { iso2: "lu", phone_code: "352" },
  "Macau S.A.R.": { iso2: "mo", phone_code: "853" },
  Macedonia: { iso2: "mk", phone_code: "389" },
  Madagascar: { iso2: "mg", phone_code: "261" },
  Malawi: { iso2: "mw", phone_code: "265" },
  Malaysia: { iso2: "my", phone_code: "60" },
  Maldives: { iso2: "mv", phone_code: "960" },
  Mali: { iso2: "ml", phone_code: "223" },
  Malta: { iso2: "mt", phone_code: "356" },
  "Man (Isle of)": { iso2: "im", phone_code: "+44-1624" },
  "Marshall Islands": { iso2: "mh", phone_code: "692" },
  Martinique: { iso2: "mq", phone_code: "596" },
  Mauritania: { iso2: "mr", phone_code: "222" },
  Mauritius: { iso2: "mu", phone_code: "230" },
  Mayotte: { iso2: "yt", phone_code: "262" },
  Mexico: { iso2: "mx", phone_code: "52" },
  Micronesia: { iso2: "fm", phone_code: "691" },
  Moldova: { iso2: "md", phone_code: "373" },
  Monaco: { iso2: "mc", phone_code: "377" },
  Mongolia: { iso2: "mn", phone_code: "976" },
  Montenegro: { iso2: "me", phone_code: "382" },
  Montserrat: { iso2: "ms", phone_code: "+1-664" },
  Morocco: { iso2: "ma", phone_code: "212" },
  Mozambique: { iso2: "mz", phone_code: "258" },
  Myanmar: { iso2: "mm", phone_code: "95" },
  Namibia: { iso2: "na", phone_code: "264" },
  Nauru: { iso2: "nr", phone_code: "674" },
  Nepal: { iso2: "np", phone_code: "977" },
  Netherlands: { iso2: "nl", phone_code: "31" },
  "New Caledonia": { iso2: "nc", phone_code: "687" },
  "New Zealand": { iso2: "nz", phone_code: "64" },
  Nicaragua: { iso2: "ni", phone_code: "505" },
  Niger: { iso2: "ne", phone_code: "227" },
  Nigeria: { iso2: "ng", phone_code: "234" },
  Niue: { iso2: "nu", phone_code: "683" },
  "Norfolk Island": { iso2: "nf", phone_code: "672" },
  "North Korea": { iso2: "kp", phone_code: "850" },
  "Northern Mariana Islands": { iso2: "mp", phone_code: "+1-670" },
  Norway: { iso2: "no", phone_code: "47" },
  Oman: { iso2: "om", phone_code: "968" },
  Pakistan: { iso2: "pk", phone_code: "92" },
  Palau: { iso2: "pw", phone_code: "680" },
  "Palestinian Territory Occupied": { iso2: "ps", phone_code: "970" },
  Panama: { iso2: "pa", phone_code: "507" },
  "Papua new Guinea": { iso2: "pg", phone_code: "675" },
  Paraguay: { iso2: "py", phone_code: "595" },
  Peru: { iso2: "pe", phone_code: "51" },
  Philippines: { iso2: "ph", phone_code: "63" },
  "Pitcairn Island": { iso2: "pn", phone_code: "870" },
  Poland: { iso2: "pl", phone_code: "48" },
  Portugal: { iso2: "pt", phone_code: "351" },
  "Puerto Rico": { iso2: "pr", phone_code: "+1-787 and 1-939" },
  Qatar: { iso2: "qa", phone_code: "974" },
  Reunion: { iso2: "re", phone_code: "262" },
  Romania: { iso2: "ro", phone_code: "40" },
  Russia: { iso2: "ru", phone_code: "7" },
  Rwanda: { iso2: "rw", phone_code: "250" },
  "Saint Helena": { iso2: "sh", phone_code: "290" },
  "Saint Kitts And Nevis": { iso2: "kn", phone_code: "+1-869" },
  "Saint Lucia": { iso2: "lc", phone_code: "+1-758" },
  "Saint Pierre and Miquelon": { iso2: "pm", phone_code: "508" },
  "Saint Vincent And The Grenadines": { iso2: "vc", phone_code: "+1-784" },
  "Saint-Barthelemy": { iso2: "bl", phone_code: "590" },
  "Saint-Martin (French part)": { iso2: "mf", phone_code: "590" },
  Samoa: { iso2: "ws", phone_code: "685" },
  "San Marino": { iso2: "sm", phone_code: "378" },
  "Sao Tome and Principe": { iso2: "st", phone_code: "239" },
  "Saudi Arabia": { iso2: "sa", phone_code: "966" },
  Senegal: { iso2: "sn", phone_code: "221" },
  Serbia: { iso2: "rs", phone_code: "381" },
  Seychelles: { iso2: "sc", phone_code: "248" },
  "Sierra Leone": { iso2: "sl", phone_code: "232" },
  Singapore: { iso2: "sg", phone_code: "65" },
  "Sint Maarten (Dutch part)": { iso2: "sx", phone_code: "1721" },
  Slovakia: { iso2: "sk", phone_code: "421" },
  Slovenia: { iso2: "si", phone_code: "386" },
  "Solomon Islands": { iso2: "sb", phone_code: "677" },
  Somalia: { iso2: "so", phone_code: "252" },
  "South Africa": { iso2: "za", phone_code: "27" },
  "South Georgia": { iso2: "gs", phone_code: "500" },
  "South Korea": { iso2: "kr", phone_code: "82" },
  "South Sudan": { iso2: "ss", phone_code: "211" },
  Spain: { iso2: "es", phone_code: "34" },
  "Sri Lanka": { iso2: "lk", phone_code: "94" },
  Sudan: { iso2: "sd", phone_code: "249" },
  Suriname: { iso2: "sr", phone_code: "597" },
  "Svalbard And Jan Mayen Islands": { iso2: "sj", phone_code: "47" },
  Swaziland: { iso2: "sz", phone_code: "268" },
  Sweden: { iso2: "se", phone_code: "46" },
  Switzerland: { iso2: "ch", phone_code: "41" },
  Syria: { iso2: "sy", phone_code: "963" },
  Taiwan: { iso2: "tw", phone_code: "886" },
  Tajikistan: { iso2: "tj", phone_code: "992" },
  Tanzania: { iso2: "tz", phone_code: "255" },
  Thailand: { iso2: "th", phone_code: "66" },
  "The Bahamas": { iso2: "bs", phone_code: "+1-242" },
  Togo: { iso2: "tg", phone_code: "228" },
  Tokelau: { iso2: "tk", phone_code: "690" },
  Tonga: { iso2: "to", phone_code: "676" },
  "Trinidad And Tobago": { iso2: "tt", phone_code: "+1-868" },
  Tunisia: { iso2: "tn", phone_code: "216" },
  Turkey: { iso2: "tr", phone_code: "90" },
  Turkmenistan: { iso2: "tm", phone_code: "993" },
  "Turks And Caicos Islands": { iso2: "tc", phone_code: "+1-649" },
  Tuvalu: { iso2: "tv", phone_code: "688" },
  Uganda: { iso2: "ug", phone_code: "256" },
  Ukraine: { iso2: "ua", phone_code: "380" },
  "United Arab Emirates": { iso2: "ae", phone_code: "971" },
  "United Kingdom": { iso2: "gb", phone_code: "44" },
  "United States": { iso2: "us", phone_code: "1" },
  "United States Minor Outlying Islands": { iso2: "um", phone_code: "1" },
  Uruguay: { iso2: "uy", phone_code: "598" },
  Uzbekistan: { iso2: "uz", phone_code: "998" },
  Vanuatu: { iso2: "vu", phone_code: "678" },
  "Vatican City State (Holy See)": { iso2: "va", phone_code: "379" },
  Venezuela: { iso2: "ve", phone_code: "58" },
  Vietnam: { iso2: "vn", phone_code: "84" },
  "Virgin Islands (British)": { iso2: "vg", phone_code: "+1-284" },
  "Virgin Islands (US)": { iso2: "vi", phone_code: "+1-340" },
  "Wallis And Futuna Islands": { iso2: "wf", phone_code: "681" },
  "Western Sahara": { iso2: "eh", phone_code: "212" },
  Yemen: { iso2: "ye", phone_code: "967" },
  Zambia: { iso2: "zm", phone_code: "260" },
  Zimbabwe: { iso2: "zw", phone_code: "263" },
};
export const allCountriesMasks = {
  ac: "....",
  ad: "...-...",
  ae: ".-...-....",
  af: "..-...-....",
  ag: "...-....",
  ai: "...-....",
  al: "(...) ...-...",
  am: "..-...-...",
  an: "...-....",
  ao: "(...) ...-...",
  aq: "..-...",
  ar: "(...) ...-....",
  as: "(...) ...-....",
  at: "(...) ...-....",
  au: ".-....-....",
  aw: "...-....",
  az: "..-...-..-..",
  ba: "..-....",
  bb: "...-....",
  bd: "..-...-...",
  be: "(...) ...-...",
  bf: "..-..-....",
  bg: "(...) ...-...",
  bh: "....-....",
  bi: "..-..-....",
  bj: "..-..-....",
  bm: "(...) ...-....",
  bn: "...-....",
  bo: ".-...-....",
  br: "(..) .....-....",
  bs: "(...) ...-....",
  bt: ".-...-...",
  bw: "..-...-...",
  by: "(..) ...-..-..",
  bz: "...-....",
  ca: "(...) ...-....",
  cd: "(...) ...-...",
  cf: "..-..-....",
  cg: "..-...-....",
  ch: "..-...-....",
  ci: "..-...-...",
  ck: "..-...",
  cl: ".-....-....",
  cm: "....-....",
  cn: "..-.....-.....",
  co: "(...) ...-....",
  cr: "....-....",
  cu: ".-...-....",
  cv: "(...) ..-..",
  cw: "...-....",
  cy: "..-...-...",
  cz: "(...) ...-...",
  de: "...-...",
  dj: "-..-..-..-..",
  dk: "..-..-..-..",
  dm: "(...) ...-....",
  do: "(...) ...-....",
  dz: "..-...-....",
  ec: ".-...-....",
  ee: "...-....",
  eg: "(...) ...-....",
  er: ".-...-...",
  es: "(...) ...-...",
  et: "-..-...-....",
  fi: "(...) ...-..-..",
  fj: "..-.....",
  fk: ".....",
  fm: "...-....",
  fo: "...-...",
  fr: "(...) ...-...",
  ga: ".-..-..-..",
  gd: "(...) ...-....",
  ge: "(...) ...-...",
  gf: ".....-....",
  gh: "(...) ...-...",
  gi: "...-.....",
  gl: "..-..-..",
  gm: "(...) ..-..",
  gn: "..-...-...",
  gq: "..-...-....",
  gr: "(...) ...-....",
  gt: ".-...-....",
  gu: "(...) ...-....",
  gw: ".-......",
  gy: "...-....",
  hk: "....-....",
  hn: "....-....",
  hr: "..-...-...",
  ht: "..-..-....",
  hu: "(...) ...-...",
  id: "(...) ...-..-...",
  ie: "(...) ...-...",
  il: ".-...-....",
  in: ".....-.....",
  io: "...-....",
  iq: "(...) ...-....",
  ir: "(...) ...-....",
  is: "...-....",
  it: "(...) ....-...",
  jm: "(...) ...-....",
  jo: ".-....-....",
  jp: "(...) ...-...",
  ke: "-...-......",
  kg: "(...) ...-...",
  kh: "..-...-...",
  ki: "..-...",
  km: "..-.....",
  kn: "(...) ...-....",
  kp: "-....-.............",
  kr: "..-...-....",
  kw: "....-....",
  ky: "(...) ...-....",
  kz: "(...) ...-..-..",
  la: "..-...-...",
  lb: ".-...-...",
  lc: "(...) ...-....",
  li: "(...) ...-....",
  lk: "..-...-....",
  lr: "..-...-...",
  ls: ".-...-....",
  lt: "(...) ..-...",
  lu: "(...) ...-...",
  lv: "..-...-...",
  ly: "...-....",
  ma: "..-....-...",
  mc: "..-...-...",
  md: "....-....",
  me: "..-...-...",
  mg: "..-..-.....",
  mh: "...-....",
  mk: "..-...-...",
  ml: "..-..-....",
  mm: "...-...",
  mn: "-..-..-....",
  mo: "....-....",
  mp: "(...) ...-....",
  mq: "(...) ..-..-..",
  mr: "..-..-....",
  ms: "(...) ...-....",
  mt: "....-....",
  mu: "...-....",
  mv: "...-....",
  mw: ".-....-....",
  mx: "... ... ....",
  my: ".-...-...",
  mz: "..-...-...",
  na: "..-...-....",
  nc: "..-....",
  ne: "..-..-....",
  nf: "...-...",
  ng: "(...) ...-....",
  ni: "....-....",
  nl: "..-...-....",
  no: "(...) ..-...",
  np: "..-...-...",
  nr: "...-....",
  nu: "....",
  nz: "(...) ...-....",
  om: "..-...-...",
  pa: "-...-....",
  pe: "(...) ...-...",
  pf: "..-..-..",
  pg: "(...) ..-...",
  ph: "(...) ...-....",
  pk: "...-.......",
  pl: "(...) ...-...",
  ps: "..-...-....",
  pt: "..-...-....",
  pw: "...-....",
  py: "(...) ...-...",
  qa: "....-....",
  re: ".....-....",
  ro: "..-...-....",
  rs: "..-..-...-....",
  ru: "(...) ...-..-..",
  rw: "(...) ...-...",
  sa: "-.-...-....",
  sb: ".....",
  sc: ".-...-...",
  sd: "-..-...-....",
  se: "..-...-....",
  sg: "....-....",
  sh: "....",
  si: "..-...-...",
  sk: "(...) ...-...",
  sl: "..-......",
  sm: "....-......",
  sn: "..-...-....",
  so: ".-...-...",
  sr: "...-...",
  ss: "..-...-....",
  st: "..-.....",
  sv: "..-..-....",
  sx: "(...) ...-....",
  sy: "..-....-...",
  sz: "..-..-....",
  tc: "(...) ...-....",
  td: "..-..-..-..",
  tg: "..-...-...",
  th: "..-...-...",
  tj: "..-...-....",
  tk: "....",
  tl: "...-.....",
  tm: ".-...-....",
  tn: "..-...-...",
  to: ".....",
  tr: "(...) ...-....",
  tt: "(...) ...-....",
  tv: ".....",
  tw: "....-....",
  tz: " ..-...-....",
  ua: "(..) ...-..-..",
  ug: "... ...-...",
  uk: ".... ......",
  us: "(...) ...-....",
  uy: ".-...-..-..",
  uz: "..-...-....",
  va: ".-...-.....",
  vc: "(...) ...-....",
  ve: ".(...) ...-....",
  vg: "(...) ...-....",
  vi: "(...) ...-....",
  vn: "(...) ....-...",
  vu: ".....",
  wf: "..-....",
  ws: "..-....",
  ye: "..-...-...",
  za: "..-...-....",
  zm: "..-...-....",
  zw: ".-......",
};

export const LDR_HEADERS_AND_KEYS = {
  keys: [
    "filling_month",
    "filling_year",
    "record_type",
    "activity",
    "manufacturing_id",
    "mfr_name",
    "mfr_st1",
    "mfr_st2",
    "mfr_city",
    "mfr_st",
    "mfr_county",
    "mfr_zip",
    "brand_id",
    "brand_other",
    "frg_mfr",
    "first_imp_name",
    "first_imp_st_1",
    "first_imp_st_2",
    "first_imp_city",
    "first_imp_st",
    "first_imp_zip_code",
    "c_sticks",
    "lc_sticks",
    "ryo_oz",
    "c_pack_size",
    "lc_pack_size",
    "stp_tx_for",
    "tax_st_paid",
    "st_id",
    "vendor_name",
    "vendor_str_1",
    "vendor_str_2",
    "vendor_city",
    "vendor_state",
    "vendor_zip_code",
    "cust_type",
    "cust_name",
    "cust_st_1",
    "cust_st_2",
    "cust_city",
    "cust_state",
    "cust_zip_code",
    "invoice_date",
    "invoice_num",
    "reason_code",
    "other_reason",
    "adj_dir",
    "ret_source_name",
    "ret_source_st1",
    "ret_source_st2",
    "resource_city",
    "ret_source_st",
    "ret_zip_code",
    "credit_memo_date",
    "credit_memo_num",
    "amend",
    "amend_reason_code",
    "amend_other_reason",
    "end_of_row",
  ],
  headers: [
    "Filling Month",
    "Filling Year",
    "Record Type",
    "Activity",
    "Manufacturing ID",
    "MfrOther",
    "MfrSt1",
    "MfrSt2",
    "MfrCity",
    "MfrSt",
    "MfrCnty",
    "MfrZip",
    "Brand ID",
    "BrandOther",
    "FrgMfr",
    "FstImpName",
    "FstImpSt1",
    "FstImpSt2",
    "FstImpCity",
    "FstImpSt",
    "FstImpZip",
    "CSticks",
    "LCSticks",
    "Ryo_OZ",
    "C-PackSize",
    "LC-PackSize",
    "STP-TxFor",
    "TaxStPaid",
    "StID",
    "VendName",
    "VendSt1",
    "VendSt2",
    "VendCity",
    "VendSt",
    "VendZip",
    "CustType",
    "CustName",
    "CustSt1",
    "CustSt2",
    "CustCity",
    "CustSt",
    "CustZip",
    "AR-Doc-Date",
    "AR-Doc-Ref-Num",
    "ADJ-Reason-Code",
    "ADJ_Other-Reason",
    "ADJ_Dir",
    "ADJ_RetName",
    "ADJ_RetSt1",
    "ADJ_RetSt2",
    "ADJ_RetCity",
    "ADJ_RetSt",
    "ADJ_RetZip",
    "ADJ_CRM_Date",
    "ADJ_CRM_Num",
    "Amend",
    "AmendRC",
    "AmendOt",
    "EndOfRow",
  ],
};

export const RCR_HEADERS_AND_KEYS = {
  keys: [
    "order_num",
    "order_date",
    "transaction_code",
    "customer_type",
    "company_name",
    "invoice_id_type",
    "tobacco_license_num",
    "address",
    "city",
    "state",
    "zip",
    "country",
    "description",
    "other_manufacturer_brand",
    "stamp_type",
    "packs_20",
    "packs_25",
  ],
  headers: [
    "Order Number",
    "Order Date",
    "Transaction Code",
    "Customer Type",
    "Company Name",
    "Invoice ID Type",
    "Tobacco License Number",
    "Address",
    "City",
    "State",
    "ZIP",
    "Country",
    "Description",
    "Other Manufacturer Brand",
    "Stamp Type",
    "Packs of 20",
    "Packs of 25",
  ],
};
export const IAR_HEADERS_AND_KEYS = {
  keys: [
    "product_name",
    "sku",
    "upc",
    "brand_name",
    "category_name",
    "performed_by",
    "last_updated_date_and_time",
    "old_available_qty",
    "new_available_qty",
    "old_damaged_qty",
    "new_damaged_qty",
    "adjusted_qty",
    "net_cost_price"
  ],
  headers: [
    "Product",
    "SKU",
    "UPC",
    "Brand",
    "Category",
    "Performed By",
    "Date & Time",
    "Old Avail Qty",
    "New Avail Qty",
    "Old Dmg Qty",
    "New Dmg Qty",
    "Adj Qty",
    "Net Cost Price"
  ],
};

export const RAP_HEADERS_AND_KEYS = {
  keys: [
    "inf_reporting_account_no",
    "customer_no",
    "retail_fein",
    "retailer_location_account_no",
    "beer_permit_no",
    "retailer_name",
    "contact_name",
    "address_line_1",
    "address_line_2",
    "city",
    "state",
    "zip",
    "zip_plus4",
    "phone",
    "county",
    "invoice_number",
    "invoice_date",
    "total_invoice_amount",
    "category_number",
    "category_name",
    "category_invoice_subtotal",
  ],
  headers: [
    "Info Report Account No",
    "Customer No",
    "Retail FEIN/SSN",
    "Retailer Location Account No",
    "Beer Permit No",
    "Retailer Name",
    "Contact Name",
    "Address Line 1",
    "Address Line 2",
    "City",
    "State",
    "Zip",
    "Zip +4",
    "Phone",
    "County",
    "Invoice Number",
    "Invoice Date",
    "Total Invoice Amount",
    "Category Number",
    "Category Name",
    "Category Invoice Subtotal",
  ],
};

export const CPR_HEADERS_AND_KEYS = {
  keys: [
    "customer_name",
    "address",
    "business_name",
    "country",
    "state",
    "city",
    "county",
    "msa",
    "tier_id",
    "invoice_count",
    "invoice_amount",
    "invoice_amount_with_tax",
    "payment_amount",
    "average_invoice_amount",
    "failed_payment_amount",
  ],
  headers: [
    "Customer Name",
    "Address",
    "Business Name",
    "Country",
    "State",
    "City",
    "County",
    "MSA",
    "Tier",
    "Invoice Count",
    "Invoice Amount",
    "Invoice Amount With Tax",
    "Payment Amount",
    "Average Invoice Amount",
    "Failed Payment Amount",
  ],
};

export const DAY_WISE_REPORT_HEADERS_AND_KEYS = {
  keys: [],
  headers: [],
};

export const CHECK_REPORT_ENV_FOR_TOTAL = ["https://andywhs.pkhub.dev", "https://anr.pkhub.dev"];

// NMI constants start

export const Payment_type = {
  CREDIT_DEBIT_GATEWAY: "3",
  CREDIT_DEBIT_TERMINAL: "13",
};

export const Payment_sub_type = {
  NMI: "1",
  STRIPE: "2",
  ECONDOIT: "3",
};

// NMI constants end

// Tax constants starts
export const TAX_REGION = {
  STATE: {
    value: 1,
    backendValue: 1,
    label: "State-level",
    name: "States",
  },
  COUNTY: {
    value: 2,
    backendValue: 2,
    label: "County-level",
    name: "Counties",
  },
  CITY: {
    value: 3,
    backendValue: 3,
    label: "City-level",
    name: "Cities",
  },
  NONE: {
    label: "No Region",
    value: null,
    backendValue: 4,
    name: "No Region",
  },
};

export const TAX_REGION_OBJ = {
  1: TAX_REGION.STATE,
  2: TAX_REGION.COUNTY,
  3: TAX_REGION.CITY,
  null: TAX_REGION.NONE,
};

export const TAX_APPLIED_TO = {
  CUSTOMER_ADDRESS: {
    label: "Customer Address",
    value: 1,
  },
  WAREHOUSE_ADDRESS: {
    label: "Warehouse Address",
    value: 2,
  },
};

export const TAX_APPLIED_TO_OBJ = {
  1: TAX_APPLIED_TO.CUSTOMER_ADDRESS,
  2: TAX_APPLIED_TO.WAREHOUSE_ADDRESS,
};

export const TAX_CHARGE_AT = {
  SALE_ORDER: {
    value: 1,
    label: "Sale Order",
  },
  PURCHASE_ORDER: {
    value: 2,
    label: "Purchase Order",
  },
};

export const TAX_CHARGED_OBJ = {
  1: TAX_CHARGE_AT.SALE_ORDER,
  2: TAX_CHARGE_AT.PURCHASE_ORDER,
};

export const TAX_ATTRIBUTE_TYPE = {
  SYSTEM: "system",
  CUSTOM: "custom",
};
// Purchase Order Invoice Flag

export const PURCHASE_ORDER_INVOICE = "purchaseOrderInvoice";
export const PURCHASE_ORDER_RECEIVE_INVOICE = "purchaseOrderReceiveInvoice";
export const PURCHASE_ORDER_RETURN_INVOICE = "purchaseOrderReturnInvoice";

export const getProductQuantity = (purchaseOrderInvoiceFlag, product) => {
  switch (purchaseOrderInvoiceFlag) {
    case PURCHASE_ORDER_INVOICE:
      return Number(product?.ordered_qty);
    case PURCHASE_ORDER_RECEIVE_INVOICE:
      return Number(product?.qty);
    case PURCHASE_ORDER_RETURN_INVOICE:
      return Number(product?.returned_qty ?? product.qty);
    default:
      return Number(product?.qty ?? product?.quantity);
  }
};

export const SettingFieldTypes = {
  COLOR: "color",
  SLIDER: "slider",
  SLIDER_SETTING: "slider_setting",
  FONT: "font",
  IMAGE: "image",
  TEXT: "text",
  RTE: "rteEditor",
  SWITCH: "switch",
  INPUT: "input",
  PHONE: "phone",
  TEMPLATE: "template",
  PAGESELECT: "pageSelect",
  CATEGORYSORTER: "categorySorter",
  CATEGORYSELECT: "categorySelect",
  DYNAMIC: "dynamic",
  RADIOGROUP: "radiogroup",
  DROPDOWNSELECT: "dropdownSelect",
  TITLE: "title",
  MULTIFIELDROPDOWN: "multiFieldDropdown",
  LINKBUTTON: "linkButton",
  GRADIENT: "gradient",
  COLLECTIONITEMS: "collectionItems",
  LINKTARGET: "linkTarget",
  ICONSELECT: "iconSelect",
};

export const SALE_ORDER_PRICE_TYPE = {
  PROMOTION_PRICE: 1,
  LAST_SOLD_PRICE: 2,
  CUSTOMER_GROUP_PRICE: 3,
  CUSTOMER_TIER_PRICE: 4,
};

export const FILTERS_CONSTANTS = {
  ONLINE_PRODUCTS: [
    {
      value: "is_online",
      name: "Show Online Products",
    },
    {
      value: "is_featured",
      name: "Show Featured Products",
    },
    {
      value: "is_hot_seller",
      name: "Show Hot Sellers Products",
    },
    {
      value: "is_promotion",
      name: "Show Sale Products",
    },
    {
      value: "is_new_arrival",
      name: "Show New Arrival Products",
    },
  ],
  MSA_PRODUCTS: [
    {
      value: 1,
      name: "Show MSA Products",
    },
    {
      value: 0,
      name: "Show All Products",
    },
  ],
  TAXABLE_PRODUCTS: [
    {
      value: 1,
      name: "Taxable Products",
    },
    {
      value: 0,
      name: "Non Taxable Products",
    },
    {
      value: 3,
      name: "All Products",
    },
  ],
  TAX_APPLIED: [
    {
      value: "Y",
      name: "Yes",
    },
    {
      value: "N",
      name: "No",
    },
  ],
  IS_EXEMPTED_FROM_TAX: [
    {
      value: "N",
      name: "Taxable Customers",
    },
    {
      value: "Y",
      name: "Non Taxable Customers",
    },
    {
      value: "N,Y",
      name: "Taxable & Non Taxable Customers",
    },
  ],
  STOCK_ALERT: [
    {
      value: 1,
      name: "Show Stock Alerts",
    },
  ],
  DAMAGE_PRODUCT: [
    {
      value: 1,
      name: "Show Damaged Stock",
    },
  ],
  OUT_OF_STOCK_PRODUCT: [
    {
      value: "0",
      name: "Out of Stock",
    },
  ],
  SHOW_CUSTOMER: [
    {
      value: -1,
      name: "Show All Customer",
    },
    {
      value: 1,
      name: "Show Active Customer",
    },
    {
      value: 0,
      name: "Show InActive Customer",
    },
    {
      value: "all",
      name: "All Customer",
    },
    {
      value: "Y",
      name: "Ecom Customer",
    },
    {
      value: "N",
      name: "Non-Ecom Customer",
    },
    {
      value: "",
      name: "None",
    },
    {
      value: "all",
      name: "All Licenses",
    },
    {
      value: "Tobacco License",
      name: "Tobacco License",
    },
    {
      value: "Business Certificate",
      name: "Business Certificate",
    },
    {
      value: "Resale Certificate",
      name: "Resale Certificate",
    },
    {
      value: "State Id License",
      name: "State Id License",
    },
  ],
  CUSTOMER_TYPE: [
    {
      value: 0,
      name: "All",
    },
    {
      value: 1,
      name: "Walk In",
    },
    {
      value: 2,
      name: "Online",
    },
  ],
  GUEST: [
    {
      value: 1,
      name: "Guest Customers",
    },
  ],
  SHIPPING: [
    {
      value: 1,
      name: "Pick Up",
    },
    {
      value: 2,
      name: "Delivery",
    },
    {
      value: 3,
      name: "Drop off",
    },
  ],
  PAYMENT_CATEGORY: [
    {
      value: 1,
      name: "Payment Received",
    },
    {
      value: 2,
      name: "Receipt Returned",
    },
    {
      value: 3,
      name: "Paid",
    },
    {
      value: 4,
      name: "Payment Returned",
    },
    {
      value: 5,
      name: "Mutual Payment",
    },
    {
      value: 6,
      name: "Account Recharge",
    },
  ],
  PAYMENT_CATEGORIES: [
    {
      value: "1,5,6",
      name: "Payment Received",
    },
    {
      value: 2,
      name: "Receipt Refunded",
    },
  ],
  STATUSES: [
    {
      value: 1,
      name: "Returned",
    },
    {
      value: 2,
      name: "In Progress",
    },
    {
      value: 4,
      name: "Partially Received",
    },
    {
      value: 5,
      name: "Received",
    },
    {
      value: 3,
      name: "Canceled",
    },
    {
      value: 6,
      name: "Completed",
    },
    {
      value: 7,
      name: "Partially Returned",
    },
    {
      value: 8,
      name: "Parked",
    },
  ],
  PAYMENT_TYPE: [
    {
      value: 3,
      name: "Credit/Debit Card",
    },
    {
      value: 12,
      name: "Ach",
    },
    {
      value: 1,
      name: "Cash",
    },
    {
      value: 2,
      name: "Cheque",
    },
    {
      value: 4,
      name: "Cash On Delivery",
    },
    {
      value: 5,
      name: "Zelle Wire Transfer",
    },
    {
      value: 6,
      name: "On Account",
    },
    {
      value: 7,
      name: "Money Order",
    },
    {
      value: 8,
      name: "Customer Credit Used",
    },
    {
      value: 9,
      name: "Customer Credit Added",
    },
  ],
  PAYMENT_SUBTYPE: [
    { name: "Offline Payment", value: 4 },
    { name: "Key in Credit/Debit Card Payment", value: 5 },
    { name: "Paid CC Terminal", value: 6 },
  ],
  PAYMENT_STATUS: [
    {
      value: 1,
      name: "Pending",
    },
    {
      value: 2,
      name: "Paid",
    },
    {
      value: 3,
      name: "Fully Refunded",
    },
    {
      value: 4,
      name: "Partially Refunded",
    },
    {
      value: 5,
      name: "Void",
    },
    {
      value: 6,
      name: "Failed",
    },
    {
      value: 7,
      name: "Unknown",
    },
    {
      value: 8,
      name: "Returned",
    },
  ],
  SCHEDULE_STATUS: [
    {
      value: 1,
      name: "Pending",
    },
    {
      value: 2,
      name: "Completed",
    },
    {
      value: 3,
      name: "Failed",
    },
  ],
  FILTER_PRODUCT_IMAGE: [
    {
      value: 1,
      name: "Show Product With Image",
    },
    {
      value: 2,
      name: "Show Product Without Image",
    },
    {
      value: 3,
      name: "Show All Product",
    },
  ],
  SALE_TYPE_FILTER: [
    {
      value: 1,
      name: "Sale Order",
    },
    {
      value: 2,
      name: "Sale Return",
    },
  ],
  IN_OUT_STATE: [
    {
      value: 1,
      name: "Out of State",
    },
    {
      value: 0,
      name: "In the State",
    },
  ],
  PO_REPORT_STATUS: [
    {
      value: 1,
      name: "Received",
    },
    {
      value: 2,
      name: "Pending",
    },
  ],

  CUSTOMER_BALANCE_TYPE: [
    {
      value: 2,
      name: "Account Receivable Customers",
    },
    {
      value: 1,
      name: "Credit Customers",
    },
  ],
  SUPPLIEROPTIONS: [
    {
      name: "Payable Amount",
      value: 1,
    },
    {
      name: "Credit Amount",
      value: 2,
    },
  ],
  PAYMENT_CATEGORY: [
    {
      value: "1,6",
      name: "Payment Received",
    },
    {
      value: 2,
      name: "Payment Refunded",
    },
    {
      value: 6,
      name: "Account Recharge",
    },
    {
      value: 5,
      name: "Mutual Payment",
    },
  ],
  PAYMENT_CATEGORY_SUPPLIER: [
    {
      value: 3,
      name: "Paid",
    },
    {
      value: 4,
      name: "Payment Returned",
    },
  ],
  DATE_CRITERIA: [
    { anme: "Schedule Date", value: "schedule_date" },
    { name: "Activity Date", value: "activity_date" },
  ],
  PAYMENT_STATUSES: [
    {
      value: 1,
      name: "Paid",
    },
    {
      value: 2,
      name: "Unpaid",
    },
    {
      value: 3,
      name: "Partially Paid",
    },
    {
      value: 4,
      name: "Overdue",
    },
    {
      value: 5,
      name: "Void",
    },
  ],
  OVER_DUE_PERIOD: [
    { name: "0-30 days (include 30 in this)", value: 1 },
    { name: "30 - 60 days (this is actually 31 - 60 days)", value: 2 },
    { name: "60+ days  (this is actually 61 days onwards)", value: 3 },
  ],
  AGING_OVER_DUE_PERIOD: AGING_OVERDUE_PERIOD_OPTIONS.map(({ label, value }) => ({ name: label, value })),
  EXPORT_PICKUP_LIST: [
    {
      value: true,
      name: "Downloaded",
    },
    {
      value: false,
      name: "Not Downloaded",
    },
  ],
  VehicleType: [
    { name: "Bicycle", value: 1 },
    { name: "Motorcycle", value: 2 },
    { name: "Cargo Van", value: 3 },
    { name: "Box Truck", value: 4 },
    { name: "Pickup Truck", value: 5 },
  ],
  FuelType: [
    { name: "Gasoline", value: 1 },
    { name: "Diesel", value: 2 },
    { name: "Electric", value: 3 },
    { name: "Hybrid", value: 4 },
  ],
  VehicleStatus: [
    { name: "Active", value: 1 },
    { name: "Inactive", value: 0 },
    { name: "Under Maintenance", value: 2 },
  ],
  VehicleLoadCapacity: [
    { name: "Less than 2000 lbs", value: 1 },
    { name: "Between 2000 and 5000 lbs", value: 2 },
    { name: "Greater than 5000 lbs", value: 3 },
  ],
  ROUTE_STATUS: [
    { name: "Pending", value: 1 },
    { name: "In Transit", value: 2 },
    { name: "Completed", value: 3 },
    { name: "Cancelled", value: 4 },
    { name: "Terminated", value: 5 }
  ],
  DELIVERY_FULFILMENT_STATUS: [
    {
      value: 1,
      name: "Pending",
    },
    {
      value: 2,
      name: "Delivery Scheduled",
    },
    {
      value: 3,
      name: "Ready For Delivery",
    },
    {
      value: 4,
      name: "In Transit",
    },
    {
      value: 5,
      name: "Delivered",
    },
    {
      value: 6,
      name: "Delivery Exception",
    },
  ],
  SHOW_DELIVERIES: [
    { value: 1, name: "Show Archived Deliveries" },
    { value: 0, name: "Show All Deliveries" },
  ],
};

export const SettingSections = {
  GENERAL: "general",
  SECTION: "section",
  PAGE: "page",
};

export const typeOptions = [
  { label: "Suggested Preserve Price", value: 1 },
  { label: "Tax", value: 2 },
];

export const OVERDUE_PERIOD = [
  { label: "0-30 days (include 30 in this)", value: 1 },
  { label: "30 - 60 days (this is actually 31 - 60 days)", value: 2 },
  { label: "60+ days  (this is actually 61 days onwards)", value: 3 },
];

export const PAYMENT_STATUSES = [
  { label: "Paid", value: 1 },
  { label: "Unpaid", value: 2 },
  { label: "Partially Paid", value: 3 },
  { label: "Overdue", value: 4 },
  { label: "Void", value: 5 },
];
export const SALE_TYPES = [
  { label: "Sale Order", value: 1 },
  { label: "Sale Return", value: 2 },
];
export const IS_EXEMPTED_FROM_TAX = [
  { name: "Taxable", value: "N" },
  { name: "Non-Taxable", value: "Y" },
];
export function convertToBase64(str) {
  if (!str) return "";
  try {
    return btoa(unescape(encodeURIComponent(str)));
  } catch (error) {
    console.error("Error encoding to Base64:", error);
    return str; // fallback to original string
  }
}

export const VehicleType = {
  BICYCLE: { name: "Bicycle", value: 1, icon: "/media/shipping-icons/delivery-car.png" },
  MOTORCYCLE: { name: "Motorcycle", value: 2, icon: "/media/shipping-icons/delivery-car.png" },
  CARGO_VAN: { name: "Cargo Van", value: 3, icon: "/media/shipping-icons/delivery-car.png" },
  BOX_TRUCK: { name: "Box Truck", value: 4, icon: "/media/shipping-icons/delivery-car.png" },
  PICKUP_TRUCK: { name: "Pickup Truck", value: 5, icon: "/media/shipping-icons/delivery-car.png" },
};

export const FuelType = {
  GASOLINE: { name: "Gasoline", value: 1 },
  DIESEL: { name: "Diesel", value: 2 },
  ELECTRIC: { name: "Electric", value: 3 },
  HYBRID: { name: "Hybrid", value: 4 },
};

export const VehicleStatus = {
  ACTIVE: { name: "Active", value: 1, bgColor: "#7ED957", color: "#1A1A1A" },
  INACTIVE: { name: "Inactive", value: 0, bgColor: "#E24A4A", color: "#ffffff" },
  UNDER_MAINTENANCE: { name: "Under Maintenance", value: 2, bgColor: "#E2964A", color: "#1A1A1A" },
};

export const VehicleLoadCapacity = {
  LESS_THAN_2000: { name: "Less than 2000 lbs", value: 1 },
  BETWEEN_2000_AND_5000: { name: "Between 2000 and 5000 lbs", value: 2 },
  GREATER_THAN_5000: { name: "Greater than 5000 lbs", value: 3 },
};

export const getNameByValue = (value, obj, slug) => {
  const found = Object.values(obj).find((item) => item.value === +value);
  if (slug && found) {
    return found[slug] || "N/A";
  }
  return found ? found?.name || found?.type2 || found?.type : "";
};

export const getAttributeByName = (value, obj, slug, compareWith) => {
  const found = Object.values(obj).find((item) => item[compareWith] == value);
  if (slug && found) {
    return found[slug] || "N/A";
  }
  return found ? found?.name || found?.type2 || found?.type : "";
};

export const DELIVERY_ROUTE_TYPE = {
  DELIVERY: {
    name: "Delivery / Dropoff",
    value: 1,
  },
};

export const DELIVERY_SLOT = {
  MORNING: {
    name: "Morning",
    value: 1,
  },
  EVENING: {
    name: "Evening",
    value: 2,
  },
};

export const FULFILLMENT_STATUS_COLUMN = {
  PENDING: {
    value: 1,
    type2: "Pending",
    type: <FormattedMessage id="Pending" defaultMessage="Pending" />,
    bgColor: "#D2BB4E",
    color: "#4D4100",
    slug: "pending",
  },
  DELIVERY_SCHEDULED: {
    value: 2,
    type2: "Delivery Scheduled",
    type: <FormattedMessage id="Delivery Scheduled" defaultMessage="Delivery Scheduled" />,
    bgColor: "#B8D2F2",
    color: "#0A315D",
  },
  READY_FOR_DELIVERY: {
    value: 3,
    type2: "Ready For Delivery",
    type: <FormattedMessage id="Ready For Delivery" defaultMessage="Ready For Delivery" />,
    bgColor: "#A8CDBB",
    color: "#0B3E2F",
  },
  INTRANSIT: {
    value: 4,
    type2: "In Transit",
    type: <FormattedMessage id="In Transit" defaultMessage="In Transit" />,
    bgColor: "#8FB7E6",
    color: "#0C2B55",
  },
  DELIVERED: {
    value: 5,
    type2: "Delivered",
    type: <FormattedMessage id="Delivered" defaultMessage="Delivered" />,
    bgColor: "#B4E0B7",
    color: "#144F25",
  },
  DELIVERY_EXCEPTION: {
    value: 6,
    type2: "Delivery Exception",
    type: <FormattedMessage id="Delivery Exception" defaultMessage="Delivery Exception" />,
    bgColor: "#E8A3A3",
    color: "#5A1212",
  },
};

export const ROUTE_STATUS = {
  PENDING: {
    name: "Pending",
    value: 1,
    bgColor: "#D2BB4E",
    color: "#4D4100",
  },
  INTRANSIT: {
    name: "In Transit",
    value: 2,
    bgColor: "#8FB7E6",
    color: "#0C2B55",
  },
  COMPLETED: {
    name: "Completed",
    value: 3,
    bgColor: "#B4E0B7",
    color: "#144F25",
  },
  CANCELLED: {
    name: "Cancelled",
    value: 4,
    bgColor: "#E8A3A3",
    color: "#5A1212",
  },
  TERMINATED: {
    name: "Terminated",
    value: 5,
    bgColor: "#E8A3A3",
    color: "#5A1212",
  },
};

export const DELIVERY_STOP_STATUS = {
  DELIVERY_SCHEDULED: {
    name: "Delivery Scheduled",
    value: 1,
    bgColor: "#FFE699",
    color: "#383101",
  },
  INTRANSIT: {
    name: "In Transit",
    value: 2,
    bgColor: "#AFD0FF",
    color: "#011738",
  },
  DELIVERED: {
    name: "Delivered",
    value: 3,
    bgColor: "#D9FFC7",
    color: "#013805",
  },
  DELIVERY_EXCEPTION: {
    name: "Delivery Exception",
    value: 4,
    bgColor: "#F7A1A1",
    color: "#380101",
  },
};

export const PACKAGE_TYPES = [
  { value: 1, label: "Carton" },
  { value: 2, label: "Pallet" },
  { value: 3, label: "Crate" },
  { value: 4, label: "Mailer" },
];

export const PACKAGE_SHIPPING_METHODS = [
  { value: 1, label: "Parcel" },
  { value: 2, label: "Delivery" },
  { value: 3, label: "LTL" },
];

export const PACKAGE_LABEL_TEMPLATES = [
  { value: 1, label: "Standard box label" },
  { value: 2, label: "Pallet label" },
  { value: 3, label: "Minimal QR label" },
];

export const PACKAGE_PARCEL_CARRIERS = [
  { value: "ups", label: "UPS" },
  { value: "fedex", label: "FedEx" },
  { value: "usps", label: "USPS" },
];

export const DISPLAY_UNITS = [{ value: "imperial", label: "Imperial · in / lb" }];

export const SHIPPING_BILLING_TERMS = [
  { value: "prepaid", label: "Prepaid" },
  { value: "collect", label: "Collect" },
  { value: "third_party", label: "Third party" },
];

export const SHIPPING_SCENARIOS = [
  {
    key: "parcel",
    title: "Parcel order",
    summary: "Choose a preset box and a carrier service; print an internal QR label plus the carrier label.",
    detail:
      "Select Small Box, enter actual packed weight, then choose UPS Ground. The internal QR label identifies the box; the carrier label is generated separately.",
    relatedTab: "Parcel",
  },
  {
    key: "heavy",
    title: "Heavy wholesale order",
    summary: "Over the 150 lb preference, suggest LTL and use a pallet, BOL and appointment.",
    detail:
      "A 185 lb shipment matches the sample automation rule and suggests LTL. Use Standard Pallet, confirm class and NMFC, and request a delivery appointment.",
    relatedTab: "LTL Freight",
  },
  {
    key: "alias",
    title: "Different trading name",
    summary:
      "Show a customer-facing alias on your internal label while retaining accurate legal shipper and consignee details.",
    detail:
      "Edit the Shipping internal label header and display alias. Keep the shipper legal name and recipient information accurate on carrier documents and the BOL.",
    relatedTab: "Labels & QR",
  },
];

// Shown beside the package weight fields. Values are always stored in pounds.
export const PACKAGE_WEIGHT_UNITS = [
  { value: "lb", label: "lb" },
  { value: "kg", label: "kg" },
  { value: "g", label: "g" },
];
